import { ChangeEvent, useEffect, useMemo, useRef, useState } from "react";
import { PaymentMode } from "../../constants/PaymentModeConstant";

import Lottie from "lottie-react";
import moment from "moment";
import classNames from "classnames";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { getDateFormat } from "../../../helpers/dateFormat";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../template/store";
import CreditBalance from "./CreditBalance";
import PayableAmount from "./PayableAmount";
import App from "./app";
import infiniteLoop from "../../../assets/img/animated-icons/infinite-loop.json";

import {
  paymentLoader,
  resetFileName,
  resetPaymentLoaders,
  setEditPayment,
  setPaymentStatus,
  updatePaymentMode,
  updatePymtData,
  setEnkapPolling,
  resetEnkapPolling,
} from "./slices/blPaymentSlice";
import { toggleDocumentHistoryColumnShort } from "../blDetails/slices/documentHistorySlice";
import { updateBlDetailsRowColumns } from "../blDetails/slices/blDetailsTable";
import {
  faCancel,
  faCheck,
  faDownload,
  faEdit,
  faEraser,
  faInfoCircle,
  faRedo,
  faSave,
  faTimes,
  faUpload,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  matchPath,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { enableBlPayment } from "../standingInstruction/slices/standingInstructionTable";
import {
  addInvoiceToExistingPayment,
  approvePaymentManualyByLiner,
  approveSAPPaymentManualyByLiner,
  cancelPayment,
  checkDuplicateReferenceNo,
  checkDuplicateReferenceNoByPymtId,
  checkPaymentReferenceIsValid,
  editBankPymtRefNo,
  getBeneficiaryAccountList,
  getDepositSlip,
  getPaymentBanks,
  getPymtConfDetails,
  getPymtDetailsByPymtNo,
  getPymtModeOptions,
  getPymtRefNo,
  getTransactionDetails,
  initiateEnkapPayment,
  initiateEnkapCheckout,
  rejectPayment,
  revisitPayment,
  sendMailToLiner,
  submitAutoPayment,
  submitPaymentAddFund,
  submitPaymentBanks,
  updatePaymentAttachment,
  updatePaymentReferenceNo,
} from "./actions/payments";
import { getCreditBalance } from "../blRequestInstruction/components/actions/Instruction";
import {
  faArrowAltCircleLeft,
  faClock,
  faPaperPlane,
} from "@fortawesome/free-regular-svg-icons";
import { defineCustomElements, PaycargoCheckout } from "@paycargo/js-react";

import PayPalCard from "./CardPayment";
import axiosInstance from "../../../axiosSetup";
import UploadIndicator from "../../../components/common/UploadIndicator";
import { useAmountFormatter } from "../../../hooks/useAmountFormatter";
import PaymentRefUserGuid from "./PaymentRefUserGuide";
import DropzoneThingNew from "./DropzoneThingNew";
import useCDNCountry from "../../../hooks/useCDNCountry";
import { getMultiCountryAllowance } from "./actions/payments";
import ToggleDiv from "../../../components/common/ToggleDiv";
import DataTable from "../../common/components/DataTable";
import { IDataTableColumn } from "../../common/types/dataTable";
import { AESDecrypt, AESDecryptAny, AESEncrypt, encryptAndEncode } from "../../../encrypt-util";
import { Button, Card, FormLabel, Modal } from "react-bootstrap";
import { selectedPmtNumber } from "./slices/PaymentInvoiceSlice";
import { subtractVanPayableAmount } from "../../common/slices/vanBalanceSlice";
import {
  updateDashbaordRefresh,
  updateSortStateDataTable,
} from "../../common/components/DataTable/slices/DataTable";
import {
  updateSelectedAmount,
  updateSelectedRowsInvoice,
} from "../multiBlPayment/slices/multiBlPaymentSlice";
import { Form } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import { InputGroup } from "react-bootstrap";
import PaymentInvoiceList from "./PaymentInvoiceList";
import { StandaloneInvoiceDetails } from "./slices/standaloneInvoicePaymentSlice";
import { toggleMainLayout } from "../settings/slices/themeSettings";
import { getAppConfig } from "../../common/actions/userDetails";
import { useBackNavigation } from "../../../hooks/BackNavigation";
import { LoadingIndicator } from "react-select/dist/declarations/src/components/indicators";
import { getUnprefixedPathname } from "../../../helpers/utils";
import { useAsyncDebounce } from "react-table";
import useDebounce from "../../../hooks/useDebounce";
import { useLinerConfig } from "../../../hooks/useLinerConfig";
import UnsavedChangesModal from "../../../components/common/UnsavedChangesModal";
import { setDirty } from "../formDirtySlice";
import { useFormNavigationWarning } from "../../../hooks/useFormNavigationWarning";
import { StringDecoder } from "string_decoder";
import { string } from "yup";
import { response } from "msw";
import accessBankQrCode from "../../../assets/images/access_bank_qr_code_image.png";
import { openDocumentInNewTab } from "../../../helpers/openDocumentInNewTab";



defineCustomElements();

/** Shown only when opening payment with ?vanPay=1 (VAN Pay). Hardcoded UI mode until backend assigns an id. */
const VAN_PAYMENT_MODE_ID = PaymentMode.VanPayment;

function parsePayableAmountForVan(value: unknown): number {
  if (value == null || value === "") return 0;
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  const n = parseFloat(String(value).replace(/,/g, ""));
  return Number.isFinite(n) ? n : 0;
}

interface dropdownList{
  label:string,
  value:string,
  currency:string
}

interface FileUploadResult {
  rowNumber: string | number;
  popAttId?: string | number;
  docId?: string | number;
  fileName: string;
  tempFilePath?: string;
  filePath?: string;
  tempFileName?: string;
  loading?: number;
  active?: string;
}

const BlPayment = () => {
  const { t } = useTranslation();
  const isDirty = useSelector((state: RootState) => state.formDirty.isDirty);
  const [selectedCcy, setSelectedCcy] = useState("USD");
  const [selectedBeneficiary, setSelectedBeneficiary] = useState("");
  const [depositSlipPaymentId, setDepositSlipPaymentId] = useState<number | null>(null);
  const [depositSlipPaymentReference, setDepositSlipPaymentReference] = useState("");
  const [isDepositSlipDownloading, setIsDepositSlipDownloading] = useState(false);
  const [selectedTransferDate, setSelectedTransferDate] = useState<Date | null>(
    null
  );
  const [paymentAmount, setPaymentAmount] = useState("");
 const [beneficiaryAccountList, setBeneficiaryAccountList] = useState<dropdownList[]>([]);
  const [showRevisitModal, setShowRevisitModal] = useState(false);
  const [showUnsavedModal, setShowUnsavedModal] = useState(false);
  const [fisNo, setFisNo] = useState<'Y' | 'N'>('N');

  var pathname = window.location.pathname;
  var pathArray = getUnprefixedPathname().split("/");
  var lastEndpoint = pathArray[pathArray.length - 1];
  const paymentMode = useSelector(
    (state: RootState) => state.blPayment.paymentMode
  );
  const localAmount = useSelector(
    (state: RootState) => state.blPayment.localamount
  );
  const paymentTransactionDetails = useSelector(
    (state: RootState) => state?.blPayment?.paymentTransactionDetails
  );
  const unpaidData = useSelector((state: RootState) =>
    state.invoiceUnpaid.data.filter((item) => !!item.ccy && item.ccy !== "")
  );
  const standaloneInvoiceList = useSelector(
    (state: RootState) => state.standaloneInvoice.data
  );
  const [financePersonEmail, setFinancePersonEmail] = useState("");
  const [financePersonEmailError, setFinancePersonEmailError] = useState("");
  const cancelPaymentLoader = useSelector(
    (state: RootState) => state.blPayment.cancelPaymentLoader
  );

  const acceptPaymentLoader = useSelector(
    (state: RootState) => state.blPayment.acceptPaymentLoader
  );
  const rejectPaymentLoader = useSelector(
    (state: RootState) => state.blPayment.rejectPaymentLoader
  );
  const selectedRouter = useSelector(
    (state: RootState) => state.documentHistory.selectedRouter
  );
  const [showPaymentConfirm, setShowPaymentConfirm] = useState(false);
  /*  const [platformfee, setPlatformfee] = useState<number>(0); */
  const platformChargeConfigId = useSelector(
    (state: RootState) => state.blPayment.platformChargeConfigId
  );
  const [totAmt, setTotamt] = useState<any>("");

  const location = useLocation();
  const [attachedFileSize, setAttachedFileSize] = useState(0);
  const localccy = useSelector((state: RootState) => state.blPayment.localccy);
  const [paymentRefFocus, setpaymentRefFocus] = useState(false);
  const [rejectionMsg, setrejectionMsg] = useState<any>("");

  const [loading, setLoading] = useState<boolean>(false);

  const [showDuplicacy, setshowDuplicacy] = useState(false);

  const [duplicayID, setduplicayID] = useState<any>("");
  const currentDateTime = new Date().toISOString();
  const [showEditDuplicacy, setShowEditDuplicacy] = useState(false);
  const [showPaymentCancel, setPaymentCancel] = useState(false);
  const [editDuplicayMsg, seteditDuplicayMsg] = useState<any>("");
  const [methodName, setMethodName] = useState<any>("");

  const [newPaymentRef, setNewPaymentRef] = useState(false);
  const [duplicayMsg, setduplicayMsg] = useState<any>("");
  const amountDetails = useSelector(
    (state: RootState) => state.blPayment.amountDetails
  );

  const pymtConf = useSelector((data: RootState) => data.blPayment.pymtConf);
 // console.log(pymtConf,"pymtConf")

  const rowColumns = useSelector(
    (state: RootState) => state.blDetailsTable.rowColumns
  );

  // e-NKAP polling state
  const enkapPollingActive = useSelector(
    (state: RootState) => state.blPayment.enkapPollingActive
  );
  const enkapOrderId = useSelector(
    (state: RootState) => state.blPayment.enkapOrderId
  );
  const enkapPollingStartTime = useSelector(
    (state: RootState) => state.blPayment.enkapPollingStartTime
  );

  const { pmtid } = useParams();
  const mandatePmtId = AESDecrypt(pmtid);
  // Flag for when Attachment upload hard stop before CRR occurs
  console.log("mandatePmtId",mandatePmtId);
  const isAttachmentMandate =
    location.pathname.includes("unpaid") && mandatePmtId;

  const selecteData = useSelector(
    (state: RootState) => state.multiBlPayment.selectedRowsMultiPay
  );

  const selecteCredData = useSelector(
    (state: RootState) => state.creditBalance.selectedCreditData
  );

  const linerId = useSelector((state: RootState) => state.navbarTop.linerId);

  const creditBalanceList = useSelector(
    (state: RootState) => state.creditBalanceBlPayment.data
  );

  const multiplePmtRef = useSelector(
    (state: RootState) => state.paymentBlPayment.multiplePmtRef
  );
  const pmtReftabledata = useSelector(
    (state: RootState) => state.paymentBlPayment.pmtReftabledata
  );
  const bankData = useSelector(
    (state: RootState) => state.blPayment.bankOptions
  );

  const pymtModeOptions = useSelector(
    (state: RootState) => state.blPayment.pymtModeOptions
  );

  const initialInvoiceDetailsPmtId = useSelector(
    (state: RootState) => state.paymentBlPayment.initialInvoiceDetailsPmtId
  );
  const tabledata = useSelector(
    (state: RootState) => state.documentHistory.data
  );
  const invoiceDashboardData = useSelector(
    (state: RootState) => state.dashboard.invoiceDashboardList
  );
  const paymentData = useSelector((state: RootState) => state.paymentBlPayment);
  const pmtRefNo = useSelector((state: RootState) => state.payment.pmtRefNo);

  const navigate = useNavigate();
  const profileDetails: any = useSelector(
    (state: RootState) => state.userProfile.profile
  );
  const rbac = useSelector((state: RootState) => state.userProfile);
  const isLiner = profileDetails?.partnerType === "liner";
  const isCustomer = profileDetails?.partnerType === "customer";
  const isCustomerBeneficiaryAccountEditEnabled =
    isCustomer &&
    rbac?.rbacDetails?.customerBeneficiaryAccountEdit === "Y";
  const isLinerPaymentModeBankEditEnabled =
    isLiner && rbac?.rbacDetails?.linerPaymentModeBankEdit === "Y";
  const isDepositSlipDownloadEnabled =
    rbac?.rbacDetails?.depositSlipDownload === "Y";
  const shouldLoadBeneficiaryAccounts =
    isLiner || isCustomerBeneficiaryAccountEditEnabled;
  const isCustomerChequeReference =
    isCustomerBeneficiaryAccountEditEnabled && Number(paymentMode) === PaymentMode.Cheque;
  const isLinerChequeReference =
    isLinerPaymentModeBankEditEnabled && Number(paymentMode) === PaymentMode.Cheque;
  const isSplitChequeReference =
    isCustomerChequeReference || isLinerChequeReference;
  const selectedLinerId = useSelector(
    (state: RootState) => state.navbarTop.linerId
  );

  const partnerCountry = profileDetails.partnerCountry;

  const storedUserCountry =
    AESDecryptAny(window.localStorage.getItem("@user-selected-datacountry")) || [];

  const linerDataCountry = useSelector(
    (state: RootState) => state.userProfile.linerDataCountry
  );

  const selectedAmount = useSelector(
    (state: RootState) => state.multiBlPayment.selectedAmountAll
  );
  const storedCountry =
    storedUserCountry?.[0]?.loginId === profileDetails.email
      ? storedUserCountry?.[0]?.country
      : null;
  const dataCountry =
    storedCountry ?? linerDataCountry ?? profileDetails.partnerCountry ?? null;
  const invoiceCountry =
    selectedAmount[0]?.collector_code !== undefined && selectedAmount.length > 0
      ? selectedAmount[0]?.collector_code.trim()
      : dataCountry;
  const [paymentCountry, setPaymentCountry] = useState(invoiceCountry);
  const configLinerId = String(
    profileDetails.partnerType === "liner"
      ? profileDetails?.partnerId ?? ""
      : selectedLinerId ?? linerId ?? ""
  );
  const linerConfig = useLinerConfig(
    paymentCountry || dataCountry || "",
    configLinerId,
    "CURRENCY",
    "PAYMENT"
  );
  const showFinalCurrency = linerConfig?.showFinalCurrency === "Y";
  const [isBankRefDirty, setIsBankRefDirty] = useState(false)
  const handleBankRefBlur = (e: any) => {
  ///  console.log("tragett", e.target.value)
    if (e.target.value !== "") {
      setIsBankRefDirty(true);
    }
    // Option 2: Do nothing here if you want to keep dirty until explicit save
  };
  const handleNavigateAway = () => {

    _onCloseForm()


  };
  useEffect(() => {
    dispatch(
      getMultiCountryAllowance({
        country: invoiceCountry,
        linerId: selectedLinerId,
      })
    );
  }, [invoiceCountry]);

  useEffect(() => {
    dispatch(
      getMultiCountryAllowance({
        country: invoiceCountry,
        linerId: selectedLinerId,
      })
    )
    .unwrap()
    .then((res:any)=>{
     // console.log(res?.payload,'<<<payload')
    });
  }, [dataCountry,selectedLinerId]);



  useEffect(() => {
    const beneficiaryCountry = paymentCountry || dataCountry;
    if(
      !shouldLoadBeneficiaryAccounts ||
      !beneficiaryCountry ||
      !configLinerId
    ) return;
    dispatch(
      getBeneficiaryAccountList({
        country: beneficiaryCountry,
        linerId: configLinerId,
      })
    )
    .unwrap()
    .then((res:any)=>{
      //console.log(res,'<<response');

      setBeneficiaryAccountList(res);
    });
  }, [
    configLinerId,
    dataCountry,
    shouldLoadBeneficiaryAccounts,
    paymentCountry,
  ]);

  const dispatch = useDispatch<AppDispatch>();
  const onBack = useBackNavigation();
  const validationFlag = useSelector(
    (state: RootState) => state.paymentBlPayment.validationFlag
  );
  const invoiceDetails = useSelector(
    (state: RootState) => state.paymentBlPayment.invoiceDetailsPmtId
  );
  const pmtNumberdata = useSelector(
    (state: RootState) => state.paymentBlPayment.pmtNumberdata
  );

  const [showPaymentRefInfo, setPaymentRefInfo] = useState(false);


  const cdnCountry = useCDNCountry();

  const { blNum } = useParams();
  const blNumDecrypted = AESDecrypt(blNum)

  useEffect(() => {
    setFisNo('N');
  }, [blNumDecrypted, paymentCountry]);

  const pymtRefNo = useParams()?.blId;
  //console.log("pymtRefNo",pymtRefNo)
  useEffect(() => {
    return () => {
      // Cleanup on component unmount
      if (!disableFields) {
        dispatch(getPaymentBanks(1));
        dispatch(setEditPayment(false));
        dispatch(setPaymentStatus(""));
      }
      dispatch(resetPaymentLoaders());

      // Clean up e-NKAP polling state
      dispatch(resetEnkapPolling());
    };
  }, []);

  // ── e-nkap return handler ──────────────────────────────────────────────────
  // Handles terminal redirect statuses: CONFIRMED, FAILED, CANCELED/CANCELLED.
  // IN_PROGRESS is NOT terminal — the payment is still being processed by the
  // gateway. We must NOT show a toast for it here; the polling effect below
  // owns that status and will show the appropriate toast once it resolves.
  useEffect(() => {
    try {
      // Read from React Router's location.search (not window.location.search) so
      // we see the params exactly as the router delivered them, without racing
      // against replaceState calls that may have already cleaned window.location.
      const searchParams = new URLSearchParams(location.search);
      const enkapStatus  = searchParams.get('enkapStatus');
      const enkapOrderId = searchParams.get('enkapOrderId');

      if (!enkapStatus) return; // not an e-nkap return — do nothing

      const statusUpper = enkapStatus.toUpperCase();

      // IN_PROGRESS is not a terminal state — skip toast entirely and let the
      // polling effect handle it.
      if (statusUpper === 'IN_PROGRESS') return;

      if (statusUpper === 'CONFIRMED') {
        toast.success(
          `MTN Mobile Money payment successful.${enkapOrderId ? ` Ref: ${enkapOrderId}` : ''}`,
          { theme: 'colored', autoClose: 10000 }
        );
      } else if (statusUpper === 'FAILED') {
        toast.error(
          `MTN Mobile Money payment failed.${enkapOrderId ? ` Ref: ${enkapOrderId}` : ''} Please try again.`,
          { theme: 'colored', autoClose: 10000 }
        );
      } else if (statusUpper === 'CANCELED' || statusUpper === 'CANCELLED') {
        toast.warning(
          `MTN Mobile Money payment was cancelled.${enkapOrderId ? ` Ref: ${enkapOrderId}` : ''}`,
          { theme: 'colored', autoClose: 10000 }
        );
      }

      // Remove the e-nkap params from the URL bar without triggering a reload
      searchParams.delete('enkapStatus');
      searchParams.delete('enkapOrderId');
      const cleanSearch = searchParams.toString();
      const cleanUrl    = window.location.pathname + (cleanSearch ? `?${cleanSearch}` : '');
      window.history.replaceState(null, '', cleanUrl);
    } catch (error) {
      console.error('e-NKAP redirect handler error:', error);
    }
  }, [location.search]);
  // ─────────────────────────────────────────────────────────────────────────

  // e-NKAP IN_PROGRESS polling is handled entirely by Payment.tsx which is
  // always the parent component on both /payment and /blsliderpayment routes.
  // BlPayment must NOT start or run its own polling loop — doing so creates
  // a duplicate loop running in parallel with Payment.tsx's loop, causing
  // 6 poll calls, two separate timeouts, and two error toasts.
  // ─────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    if (
      paymentAmount &&
      linerId &&
      selectedCcy &&
      paymentCountry &&
      rbac?.rbacDetails?.showPaymentTransaction == "Y"
    ) {
      dispatch(
        getTransactionDetails({
          country: paymentCountry,
          ccy: selectedCcy,
          amount: paymentAmount,
          linerId: linerId,
        })
      );
    }
  }, [paymentAmount, linerId, selectedCcy, paymentCountry]);

  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
  const matchPth =
    matchPath(
      {
        ///bl/:blNum/payment/:pymtRefNo/:pmtMode
        path: `${APP_PATH_PREFIX}/bl/:blNum/payment/:pymtRefNo`,
        caseSensitive: true,
        end: true,
      },
      location.pathname
    ) ||
    matchPath(
      {
        path: `${APP_PATH_PREFIX}/instruction/bl/:blNum/payment/:pymtRefNo`,
        caseSensitive: true,
        end: true,
      },
      location.pathname
    ) ||
    matchPath(
      {
        path: `${APP_PATH_PREFIX}/payment/bl/:blNum/payment/:pymtRefNo`,
        caseSensitive: true,
        end: true,
      },
      location.pathname
    );

  function extractValuesFromUrl(url: any) {
    const params = new URLSearchParams(url);
    const sortParam = params.get("sort");

    if (sortParam) {
      const arr: any = sortParam.split("%2C");
      return arr;
    } else {
      return [];
    }
  }

  const [filteredArrayData, setFilteredArrayData] = useState<any>([]);
  const disableFields =
    isAttachmentMandate ||
      profileDetails?.partnerType === "liner" ||
      (matchPth && profileDetails?.partnerType !== "liner") ||
      location.pathname.includes("blsliderpayment")
      ? true
      : false;
console.log(disableFields,"check", isAttachmentMandate)

  useEffect(() => {
    if (!disableFields) {
      dispatch(getPaymentBanks(1));
    }
    if (!disableFields) {
      dispatch(setEditPayment(false));
      dispatch(setPaymentStatus(""));
    }
    dispatch(resetPaymentLoaders());
  }, [
    disableFields,
    dispatch,
  ]);
  const showMainLayout = useSelector(
    (state: RootState) => state.themeSettings.showMainLayout
  );

  /** Single file input — `pymtConf.paymentProofAttachment` (M / O / hidden). */
  const showPaymentProofAttachment =
    pymtConf?.paymentProofAttachment === "O" ||
    pymtConf?.paymentProofAttachment === "M";

  /** Multi dropzone — `pymtConf.paymentProofMultiAttachment` (M / O / hidden). */
  const showPaymentProofMultiAttachment =
    pymtConf?.paymentProofMultiAttachment == "O" ||
    pymtConf?.paymentProofMultiAttachment == "M";

  /** Amount Paid checkboxes — `pymtConf.amountPaidCheckbox` (M / O / hidden). */
  const showAmountPaidCheckbox =
    pymtConf?.amountPaidCheckbox == "O" ||
    pymtConf?.amountPaidCheckbox == "M";


  const allowPartialPopApproval = pymtConf?.allowPartialPopApproval == "Y";

  const hasPaymentProofUploadConfig =
    showPaymentProofMultiAttachment || showPaymentProofAttachment;

  const paymentProofMaxFilesFromConfig = Number(
    pymtConf?.paymentProofMaxFiles
  );
  const paymentProofMaxFiles =
    paymentProofMaxFilesFromConfig >= 1 ? paymentProofMaxFilesFromConfig : 1;

  useEffect(() => {
    invoiceDashboardData.result?.forEach((d: any, i: any) => {
      if (
        paymentData.pmtNumberdata?.map?.((v: any) => v.invNo).includes(d.invno)
      )
        filteredArrayData.push(d.pmtreference);
    });
    setFilteredArrayData(filteredArrayData);
  }, [invoiceDashboardData, paymentData]);

  useEffect(() => {
    if (
      isAttachmentMandate ||
      (disableFields == false &&
        (showPaymentProofMultiAttachment || showPaymentProofAttachment))
    ) {
      dispatch(getAppConfig("attachment.maxsize"))
        .unwrap()
        .then((response: any) => {
          if (response !== "") {
            setAttachedFileSize(+response.response.data);
          }
        });
    }
  }, [
    disableFields,
    pymtConf?.paymentProofAttachment,
    pymtConf?.paymentProofMultiAttachment,
    showPaymentProofMultiAttachment,
    showPaymentProofAttachment,
  ]);

  useEffect(() => {
    if (modalCloseFocus.current) {
      setTimeout(() => {
        if (modalCloseFocus.current) modalCloseFocus.current.focus();
      }, 500);
      // modalCloseFocus.current.focus();
    }
  }, [showPaymentConfirm]);

  useEffect(() => {
    if (paymentRefFocus)
      if (modalCloseFocus.current) {
        setTimeout(() => {
          if (modalCloseFocus.current) modalCloseFocus.current.focus();
        }, 500);
        // modalCloseFocus.current.focus();
      }
  }, [paymentRefFocus]);


  const [selectedTransactions, setSelectedTransactions] = useState<any[]>([]);

  const selectedBls = useSelector(
    (state: RootState) => state.multiBlPayment.selectedRowsMultiPay
  );
  const paycargoRef = useRef<any | null>(null);
  const modalCloseFocus = useRef<any>(null);
  const totalAmtVal = useRef<any>(null);
  const [env, setEnv] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [code, setCode] = useState("");
  const [options, setOptions] = useState({
    env: "test",
    code: "odex", // Provied by PayCargo
    brand: "odex", // Provied By PayCargo
    originURL: window.location.origin, // URL to whitelist
  });

  useEffect(() => {
    dispatch(getAppConfig("env"))
      .unwrap()
      .then((response: any) => {
        if (response !== "") {
          setEnv(response.response.data.toString().split("_")[0]);
          setVendorId(response.response.data.toString().split("_")[1]);
          setCode(response.response.data.toString().split("_")[2]);
        }
      });
  }, []);
  useEffect(() => {
    setOptions({
      env: env, // PROD , TEST, DEV
      code: code || "odex", // Provied by PayCargo
      brand: code || "odex", // Provied By PayCargo
      originURL: window.location.origin, // URL to whitelist
    });
  }, [env]);

  useEffect(() => {
    const newArray =
      amountDetails > 0
        ? selectedBls.map((item: any) => ({
          type: "INVOICE",
          number: item.invno,
          total: item.invamt,
          departureDate: item.invdt,
          arrivalDate: item.invdt,
          paymentDueDate: item.invdt,
          customerRefNumber: item.shipmentno || item.blno,
          parent: item.blno,
          hasArrived: "N",
          direction: item.eximindicator === "Export" ? "Outbound" : "Inbound",
          vendorId: vendorId, //278606,281573
        }))
        : [];
    const standArray = standaloneInvoiceList.map((item: any) => ({
      type: "INVOICE",
      number: item.invoiceNo,
      total: item.invoiceAmount,
      departureDate: item.invDt,
      arrivalDate: item.invDt,
      paymentDueDate: item.invDt,
      customerRefNumber: item.shipmentNumber || item.blNo,
      parent: item.blNo,
      hasArrived: "N",
      direction: item.eximindicator !== "C" ? "Outbound" : "Inbound",
      vendorId: vendorId,
    }));
    setTimeout(() => {
      setSelectedTransactions(
        location.pathname.includes("addInvoice") ? standArray : newArray
      );
    }, 100);
  }, [
    selectedBls,
    paymentMode,
    vendorId,
    amountDetails,
    standaloneInvoiceList,
  ]);

  let paycargoInvoiceList = [{}];

  const [integrationResponse, setIntegrationResponse] = useState("");

  useEffect(() => {
    if (paymentMode == PaymentMode.PayCargo) {
      const hideLayout = () => {
        dispatch(toggleMainLayout(false));
        const errorMessage = paycargoRef?.current?.shadowRoot
          ?.querySelectorAll("div")[0]
          ?.getElementsByClassName("hydrated")?.[0]
          ?.shadowRoot?.querySelectorAll("div")?.[0]
          ?.getElementsByClassName("toast error")?.[0]?.innerText;
        if (errorMessage !== undefined) dispatch(toggleMainLayout(true));
      };
      const listener = (event: any) => {
        if (event.detail.success) {
          paycargoInvoiceList = event.detail.data.success.approve.map(
            (item: any) => ({ invNo: item.number, invAmt: item.totalAmount })
          );
          setIntegrationResponse(JSON.stringify(event));
          handleSubmit();
        }
        setTimeout(() => dispatch(toggleMainLayout(true)), 150);
      };

      paycargoRef?.current?.addEventListener("close", listener);
      paycargoRef?.current?.addEventListener("paymentResponse", listener);
      paycargoRef?.current?.addEventListener("click", hideLayout);

      return () => {
        paycargoRef?.current?.removeEventListener("close", listener);
        paycargoRef?.current?.removeEventListener("paymentResponse", listener);
        paycargoRef?.current?.removeEventListener("click", hideLayout);
      };
    }
  }, [paycargoRef, paymentMode]);

  // useEffect(() => {
  //   debugger;
  //   if (paycargoInvoiceList.length > 0 && paymentMode == PaymentMode.PayCargo) {
  //     handleSubmit();
  //   }
  // }, [paycargoInvoiceList]);

  const _onCloseForm = () => {

    onBack();
    setPaymentProofMultiFiles([]);
    setAmountPaidType(null);
    setAmountPaidError(false);
    if (location.pathname.includes("unpaid")) {
      navigate(location.pathname.replace(/\/unpaid.*/, "/unpaid"));
    }
    if (location.pathname.includes("instructionpayment")) {
      dispatch(toggleDocumentHistoryColumnShort(false));

      dispatch(
        updateBlDetailsRowColumns({
          ...rowColumns,
          mainTableClass: "col-lg-2",
          documentMainViewClass: "d-none",
          documentHistoryClass: "col-lg-12",
          outletClass: "d-none",
        })
      );
    } else if (location.pathname.includes("204")) {
      dispatch(toggleDocumentHistoryColumnShort(false));

      dispatch(
        updateBlDetailsRowColumns({
          ...rowColumns,
          mainTableClass: "col-lg-2",
          documentMainViewClass: "d-none",
          documentHistoryClass: "col-lg-12",
          outletClass: "d-none",
        })
      );

      setTimeout(() => {
        //  navigate(-1);
      }, 500);
    } else if (location.pathname.includes("blsliderpayment")) {
      setTimeout(() => {
        //  navigate(`${APP_PATH_PREFIX}/payment${window.location.search || ''}`);
      }, 500);
    } else if (location.pathname.includes("payment/new")) {
      setTimeout(() => {
        //  navigate(-1);
      });
    } else if (location.pathname == "/payment/addInvoice/invoicePayment") {
      // if (window.location.search) {
      //   const paramVal = extractValuesFromUrl(window.location.search);
      //   const splitedval = paramVal[0].split(',');
      //   setTimeout(() => {
      //     //  debugger;
      //     dispatch(
      //       updateSortStateDataTable({
      //         key: splitedval[2],
      //         value: splitedval[3],
      //       })
      //     );
      //   }, 100);
      // }
      navigate(`${APP_PATH_PREFIX}/payment/addInvoice`);
    } else if (
      location.pathname.includes("payment") &&
      !location.pathname.includes("unpaid")
    ) {
      setTimeout(() => {
        if (selectedRouter === "payment") {
          // navigate(
          //   `/payment/${encodeURIComponent(blNum || '')}${
          //     window.location.search || ''
          //   }`
          // );

          if (window.location.search) {
            const paramVal = extractValuesFromUrl(window.location.search);
            const splitedval = paramVal[0].split(",");
            setTimeout(() => {
              //  debugger;
              dispatch(
                updateSortStateDataTable({
                  key: splitedval[0],
                  value: splitedval[1],
                })
              );
            }, 100);
          }
        } else if (selectedRouter == "instruction") {
          // navigate(
          //   `/instruction/${encodeURIComponent(blNum || '')}${
          //     window.location.search || ''
          //   }`
          // );

          if (window.location.search) {
            const paramVal = extractValuesFromUrl(window.location.search);
            const splitedval = paramVal[0].split(",");
            setTimeout(() => {
              dispatch(
                updateSortStateDataTable({
                  key: splitedval[0],
                  value: splitedval[1],
                })
              );
            }, 100);
          }
        } else {
          if (window.location.search) {
            const paramVal = extractValuesFromUrl(window.location.search);
            const splitedval = paramVal[0].split(",");
            setTimeout(() => {
              //  debugger;
              dispatch(
                updateSortStateDataTable({
                  key: splitedval[0],
                  value: splitedval[1],
                })
              );
            }, 100);
          }
        }
      }, 500);
    } else {
      // navigate(-1);
      dispatch(enableBlPayment(false));
    }
  };

  const onChangePaymentMode = (e: ChangeEvent<HTMLSelectElement>) => {
    setDepositSlipPaymentId(null);
    setDepositSlipPaymentReference("");
    dispatch(updatePaymentMode(e.target.value));
  };

  const selectedDocHistory: any = useSelector(
    (state: RootState) => state.documentHistory.data
  );

  const usdPayableAmount =
    window.location.pathname === "/multi-payment"
      ? selectedBls
        .filter((v: any) => v.currency === "USD")
        .map((i: any) => Number(i.amount))
        .reduce((partialSum: any, a: any) => partialSum + a, 0)
      : selectedDocHistory
        .filter((v: any) => v.currency === "USD")
        .map((i: any) => Number(i.amount))
        .reduce((partialSum: any, a: any) => partialSum + a, 0);

  const zarPayableAmount =
    window.location.pathname === "/multi-payment"
      ? selectedBls
        .filter((v: any) => v.currency === "ZAR")
        .map((i: any) => Number(i.amount))
        .reduce((partialSum: any, a: any) => partialSum + a, 0)
      : selectedDocHistory
        .filter((v: any) => v.currency === "ZAR")
        .map((i: any) => Number(i.amount))
        .reduce((partialSum: any, a: any) => partialSum + a, 0);

  const [selected, setSelected] = useState(bankData[0]?.value);
  const [bnkName, setBnkName] = useState(bankData[0]?.bankName || "");
  const [acName, setAcName] = useState(bankData[0]?.accountNo || "");
  const [inputValue, setInputValue] = useState("");
  const [inputValueTemp, setInputValueTemp] = useState<any>("");

  const [radioValue, setRadioValue] = useState("auto");
  const [pmtId, setPmtId] = useState(0);
  const [paymentDetails, setPaymentDetails] = useState<any>();
  const chequeOdexReference = paymentDetails?.odexRefNo || pmtRefNo || "";

  console.log("paymentDetails",paymentDetails?.userEmailId);

  useEffect(() => {
    if (
      !disableFields &&
      ((radioValue === "auto" && inputValueTemp?.trim() === "") ||
        (isCustomerChequeReference && !pmtRefNo)) &&
      partnerCountry
    ) {
      dispatch(
        getPymtRefNo({
          partnerCountry,
        })
      );
    }
  }, [radioValue, partnerCountry, inputValueTemp, disableFields, isCustomerChequeReference, pmtRefNo]);

  useEffect(() => {
    if (radioValue === "auto") {
      if (pmtRefNo) setInputValue(pmtRefNo);
      setInputValueTemp(pymtRefNo);
    }
  }, [pmtRefNo, radioValue]);
  useEffect(() => {
    if (
      (paymentMode == PaymentMode.Cheque && !disableFields) ||
      ((paymentMode == PaymentMode.BankTransfer || paymentMode == VAN_PAYMENT_MODE_ID) &&
        dataCountry == "PK")
    ) {
      setRadioValue("generate");
      setInputValueTemp("inputValue");
      setInputValue("");
    } else if (
      (paymentMode == PaymentMode.BankTransfer || paymentMode == VAN_PAYMENT_MODE_ID) &&
      !disableFields &&
      dataCountry === "SG"
    ) {
      setRadioValue("auto");
      setInputValue("");
    } else if (
      (paymentMode == PaymentMode.BankTransfer || paymentMode == VAN_PAYMENT_MODE_ID) &&
      !disableFields
    ) {
      setRadioValue("auto");
    }
  }, [paymentMode, disableFields, paymentCountry]);

  useEffect(() => {
    const newval = pmtReftabledata.reduce(
      (sum: any, obj: { invAmt: string }) =>
        sum +
        (typeof obj.invAmt === "string" ? parseFloat(obj.invAmt) : obj.invAmt),
      0
    );
    totalAmtVal.current = newval;
    setselectedTotal(newval);
  }, [pmtReftabledata]);

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setDepositSlipPaymentId(null);
    setDepositSlipPaymentReference("");
    setSelected(e.target.value);
    setBnkName(
      e.target.value
        ? bankData.find((v: any) => v.value == e.target.value)?.bankName || ""
        : ""
    );
    setAcName(
      e.target.value
        ? bankData.find((v: any) => v.value == e.target.value)?.accountNo || ""
        : ""
    );
  };
  const handleBeneficiaryChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setDepositSlipPaymentId(null);
    setDepositSlipPaymentReference("");
    setSelectedBeneficiary(e.target.value);
    dispatch(setDirty());
  };
  const isEximBeneficiarySelected = () => {
    const selectedBeneficiaryAccount = beneficiaryAccountList.find(
      (option: any) => String(option.value) === String(selectedBeneficiary)
    );
    const selectedBeneficiaryLabel = String(
      selectedBeneficiaryAccount?.label ??
        paymentDetails?.beneficiaryAccountName ??
        paymentDetails?.beneficiaryBank ??
        ""
    );
    return selectedBeneficiaryLabel.toUpperCase().includes("EXIM BANK");
  };
  const makeEximDepositSlipAvailable = (submissionResult: any) => {
    const submittedPaymentId = Number(submissionResult?.pmtId);
    const isSuccessfulSubmission =
      submissionResult?.success === true || submissionResult?.success === "true";
    if (
      !isDepositSlipDownloadEnabled ||
      !isEximBeneficiarySelected() ||
      !isSuccessfulSubmission ||
      !Number.isFinite(submittedPaymentId) ||
      submittedPaymentId <= 0
    ) {
      return false;
    }
    setDepositSlipPaymentId(submittedPaymentId);
    setDepositSlipPaymentReference(
      String(
        Number(paymentMode) === PaymentMode.Cheque ? pmtRefNo : inputValue
      ).trim()
    );
    dispatch(paymentLoader(false));
    toast.success("Exim Bank Deposit Slip available to download", {
      theme: "colored",
      autoClose: 5000,
      position: "top-right",
    });
    return true;
  };
  const downloadEximDepositSlip = async (paymentId: number) => {
    if (!paymentId) return;
    try {
      setIsDepositSlipDownloading(true);
      const paymentReferenceNo =
        paymentId === depositSlipPaymentId
          ? depositSlipPaymentReference
          : String(paymentDetails?.odexRefNo ?? "").trim();
      const { pdfBlob, fileName } = await dispatch(
        getDepositSlip({ pmtId: paymentId, paymentRefNo: paymentReferenceNo })
      ).unwrap();
      const fileUrl = URL.createObjectURL(pdfBlob);
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(fileUrl);
    } catch {
      toast.error("Unable to download Exim Bank Deposit Slip", {
        theme: "colored",
      });
    } finally {
      setIsDepositSlipDownloading(false);
    }
  };
  const renderDepositSlipButton = (paymentId: number, className?: string) =>
    editPayment ? null : (
    <Button
      variant="falcon-primary"
      size="sm"
      className={className}
      type="button"
      onClick={() => downloadEximDepositSlip(paymentId)}
      disabled={isDepositSlipDownloading}
    >
      <FontAwesomeIcon icon={faDownload} className="me-2" />
      Download Deposit Slip
    </Button>
    );

  const pymtMode = useSelector((state: RootState) => state.blPayment.pymtMode);
  const paymentLoaderCheck = useSelector(
    (state: RootState) => state.blPayment.paymentSubmitLoader
  );
  const pymtNo = useSelector((state: RootState) => state.blPayment.pymtNo);
  const editPayment: any = useSelector(
    (state: RootState) => state.blPayment.editPayment
  );
  const bnkNm = useSelector((state: RootState) => state.blPayment.bnkNm);
  const accNo = useSelector((state: RootState) => state.blPayment.accNo);
  const pymtAmt = useSelector((state: RootState) => state.blPayment.pymtAmt);
  const pymtCurr = useSelector((state: RootState) => state.blPayment.pymtCurr);
  const platformfee = useSelector(
    (state: RootState) => state.blPayment.platformFee
  );
  const totalInvAmt = useSelector(
    (state: RootState) => state.blPayment.totalInvAmt
  );
  /** Single + multi payment proof (single uses index 0). */
  const [paymentProofMultiFiles, setPaymentProofMultiFiles] = useState<
    FileUploadResult[]
  >([]);
  console.log(paymentProofMultiFiles,"paymentProofMultiFiles")
  useEffect(() => {
    console.log(
      "!loadingFileState",
      paymentProofMultiFiles?.[0]?.loading,
      paymentProofMultiFiles?.[0]?.tempFilePath
    );
  }, [paymentProofMultiFiles]);
  type AmountPaidType = "PARTIAL" | "FULL";
  const [amountPaidType, setAmountPaidType] = useState<AmountPaidType | null>(
    null
  );
  const [amountPaidError, setAmountPaidError] = useState(false);

  const isPaymentProofReady = (f?: any) => {
    if (!f || f.loading != 100) return false;
    if (f.active != "1") return false;
    if (f.popAttId != null) {
      return !!(f.filePath || f.tempFilePath);
    } else {
      return !!f.tempFilePath;
    }
  };

  const isPaymentProofPayloadRow = (f: any) => {
    if (!f) return false;
    if (f.loading != 100) return false;
    if (f.popAttId != null) {
      return !!(f.filePath || f.tempFilePath);
    } else {
      return !!f.tempFilePath;
    }
  };

  /** Same stages as UploadThing in RefundCustomerDocuments — keyed by rowNumber. */
  const handlePaymentProofMultiSelected = (
    fileName: string
  ): string | number => {
    const rowNumber = crypto.randomUUID();
    dispatch(setDirty());
    setPaymentProofMultiFiles((prev) => [
      ...prev,
      {
        rowNumber,
        fileName,
        loading: 0,
        active: "1",
        tempFilePath: "",
        tempFileName: "",
      },
    ]);
    return rowNumber;
  };

  const handlePaymentProofMultiPending = (
    rowNumber: string | number,
    loading: number
  ) => {
    setPaymentProofMultiFiles((prev) =>
      prev.map((f) => (f.rowNumber == rowNumber ? { ...f, loading } : f))
    );
  };

  const handlePaymentProofMultiFulfilled = (
    rowNumber: string | number,
    fileName: string,
    tempFilePath: string,
    tempFileName: string
  ) => {
    dispatch(setDirty());
    setPaymentProofMultiFiles((prev) =>
      prev.map((f) =>
        f.rowNumber == rowNumber
          ? {
              ...f,
              fileName,
              tempFilePath,
              tempFileName,
              filePath: "",
              loading: 100,
            }
          : f
      )
    );
    if (
      profileDetails?.partnerType == "customer" &&
      showAmountPaidCheckbox
    ) {
      toast.info(
        "POP has been uploaded. Kindly update the Amount Paid status / checkbox before submitting"
      );
    }
  };

  const handlePaymentProofMultiFailed = (rowNumber: string | number) => {
    setPaymentProofMultiFiles((prev) =>
      prev.map((f) =>
        f.rowNumber == rowNumber
          ? {
              ...f,
              fileName: '',
              loading: -1,
              tempFilePath: "",
              tempFileName: "",
            }
          : f
      )
    );
  };

  const handlePaymentProofMultiClear = (rowNumber: string | number) => {
    dispatch(setDirty());
    setPaymentProofMultiFiles((prev) => {
      const target = prev.find((f) => f.rowNumber == rowNumber);
      if (!target) return prev;
      if (target.popAttId != null) {
        return prev.map((f) =>
          f.rowNumber == rowNumber ? { ...f, active: "0" } : f
        );
      }
      return prev.filter((f) => f.rowNumber != rowNumber);
    });
  };

  const hasActivePaymentProofAttachment = (files = paymentProofMultiFiles) =>
    (files ?? []).some(
      (f) => f.active == "1" && !!f.fileName && (f.loading ?? 0) != -1
    );

  /**
   * O = no mandate.
   * M + proof upload config = require Partial/Full only when a file is attached.
   * M without proof upload config = always require Partial/Full when shown.
   */
  const isAmountPaidRequired =
    showAmountPaidCheckbox &&
    pymtConf?.amountPaidCheckbox == "M" &&
    (hasPaymentProofUploadConfig
      ? hasActivePaymentProofAttachment()
      : true);

  /** When single/multi upload is shown, Partial/Full stay disabled until a file is attached */
  const isAmountPaidCheckboxDisabledByProof =
    hasPaymentProofUploadConfig && !hasActivePaymentProofAttachment();

  useEffect(() => {
    if (!showAmountPaidCheckbox) {
      setAmountPaidError(false);
      return;
    }
    if (isAmountPaidCheckboxDisabledByProof) {
      if (amountPaidType) {
        setAmountPaidType(null);
      }
      setAmountPaidError(false);
      return;
    }
    setAmountPaidError(isAmountPaidRequired && !amountPaidType);
  }, [
    paymentProofMultiFiles,
    amountPaidType,
    showAmountPaidCheckbox,
    pymtConf?.amountPaidCheckbox,
    hasPaymentProofUploadConfig,
    isAmountPaidCheckboxDisabledByProof,
    isAmountPaidRequired,
  ]);

  const getAmountPaidPayload = () =>
    showAmountPaidCheckbox
      ? { amountPaidStatus: amountPaidType ?? "" }
      : {};

  const validateAmountPaidBeforeSubmit = (): boolean => {
    if (!isAmountPaidRequired) {
      return true;
    }
    if (!amountPaidType) {
      setAmountPaidError(true);
      toast.error("Please select/ update the Amount Paid checkbox", {
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const paymentProofDocId = 100;

  const buildPopAttachments = (): any[] =>
    (paymentProofMultiFiles ?? [])
      .filter(isPaymentProofPayloadRow)
      .map((f) => ({
        popAttId: f.popAttId ?? null,
        docId: f.docId ?? paymentProofDocId,
        fileName: f.fileName ?? "",
        filePath: f.filePath ?? "",
        tempFileName: f.tempFileName ?? "",
        tempFilePath: f.tempFilePath ?? "",
        active: f.active ?? "1",
      }));

  const getPaymentProofDocumentLink = (f: FileUploadResult) => {
    if (f.popAttId == null || f.tempFileName || !f.filePath || f.loading != 100) return undefined;
    return `${process.env.REACT_APP_CLIENT_APP_HOST}/api/edo-rest-v2/v2/common/openDocument?id=${encryptAndEncode(f.popAttId)}&moduleTp=PAYMENT_PROOF_NEW&linerId=${encryptAndEncode(
      profileDetails.partnerType === "liner"
        ? profileDetails?.partnerId
        : selectedLinerId
    )}&rd=N`;
  };

  const openPaymentProofDocument = async (f: FileUploadResult) => {
    if (f.popAttId == null || f.tempFileName || !f.filePath || f.loading != 100) return;

    await openDocumentInNewTab({
      url: '/api/edo-rest-v2/v2/common/openDocument',
      params: {
        id: encryptAndEncode(f.popAttId),
        moduleTp: 'PAYMENT_PROOF_NEW',
        linerId: encryptAndEncode(
          profileDetails.partnerType === 'liner'
            ? profileDetails?.partnerId
            : selectedLinerId
        ),
      },
    });
  };

  const payorAccountId = useSelector(
    (state: RootState) => state.blPayment.payorAccountId
  );

  const newStandaloneInvoiceList: any = standaloneInvoiceList.map(
    (invoice: StandaloneInvoiceDetails) => {
      return {
        amount: invoice.invoiceAmount,
        finalAmount: invoice.finalAmount,
        id: invoice.invoiceNumber ?? invoice.invoiceNo,
        invID: invoice.invoiceId,
        invcurr: invoice.invoiceCurrency,
        ccy: invoice.invoiceCurrency,
      };
    }
  );
  const newUnpaidData: any = unpaidData
    .map((item) => ({
      amount: item.amount,
      id: item.invno,
      invID: item.invid,
      invcurr: item.ccy,
      localamount: item.localamount,
      localccy: item.localccy,
    }))
    .filter(
      (item) =>
        item.invcurr ===
        (unpaidData.find((item) => item.ccy != "USD")?.ccy ?? "USD")
    );

  const filteredselectedAmount = matchPath(
    `${APP_PATH_PREFIX}/payment/addInvoice/invoicePayment`,
    location.pathname
  )
    ? newStandaloneInvoiceList
    : location.pathname.includes("unpaid")
      ? newUnpaidData
      : selectedAmount.filter(
        (item: { invcurr: any; id: any; localamount: any; final_curr?: any }) =>
          item.invcurr === selectedAmount[0]?.invcurr &&
          (item?.id?.substring(0, 2) == "CD") ==
          (selectedAmount[0]?.id.substring(0, 2) == "CD") &&
          isNaN(item.localamount) == isNaN(selectedAmount[0].localamount) &&
          (item?.final_curr || null) === (selectedAmount[0]?.final_curr || null)
      );

  const selectedInvoiceCurrency = filteredselectedAmount?.[0]?.invcurr ?? "USD";
  const resolvedFinalCurr =
    filteredselectedAmount?.[0]?.final_curr ||
    paymentDetails?.finalCurr;
  const paymentCurrency =
    showFinalCurrency && resolvedFinalCurr
      ? resolvedFinalCurr
      : selectedInvoiceCurrency;

  useEffect(() => {
    if (!disableFields && paymentCurrency) {
      setSelectedCcy(paymentCurrency);
    }
  }, [disableFields, paymentCurrency]);

  const getConfig = useDebounce(() => {
    if (paymentMode && linerId && paymentCountry && (pmtId ? selectedCcy : paymentCurrency)) {
      dispatch(getPymtConfDetails({
        paymentMode, linerId, paymentCountry,
        currency: pmtId ? selectedCcy : paymentCurrency
      }));

    }
  }, 500)

  useEffect(() => {

    getConfig()

  }, [paymentMode, linerId, paymentCountry, paymentCurrency, selectedCcy, localccy, localAmount, paymentAmount, pmtId, blNumDecrypted]);


  const radioVal = useSelector(
    (state: RootState) => state.blPayment.radioValue
  );
  const pmtStatus = useSelector(
    (state: RootState) => state.blPayment.pmtStatus
  );
  const isPaidPayment =
    String(pmtStatus || paymentDetails?.pmtStatus || "")
      .trim()
      .toUpperCase() === "PAID";

  //console.log(pmtStatus,'<<pmtStatus')

  const showBeneficiary=useMemo(() => {
    return !!(pymtConf.showBeneficiary === 'Y' &&
      profileDetails.partnerType === "liner" &&
      pmtStatus?.toUpperCase() !== "PAID" &&
      pmtStatus?.toUpperCase() !== "AUTO_APPROVED" &&
      pmtStatus?.toUpperCase() !== "CANCELLED" &&
      pmtStatus?.toUpperCase() !== "REJECTED" &&
      pmtStatus !== "1" &&
      rbac.rbacDetails.paymentApproveReject === "Y"
    );
  }, [pymtConf.showBeneficiary,profileDetails.partnerType,pmtStatus,rbac.rbacDetails.paymentApproveReject]);

  const showBeneficiaryAccount =
    isCustomerBeneficiaryAccountEditEnabled ||
    (isLiner &&
      (pymtConf.showBeneficiary === "Y" ||
        Boolean(paymentDetails?.beneficiaryAccount)));
  const beneficiaryAccountOptions = useMemo(() => {
    if (
      !selectedBeneficiary ||
      beneficiaryAccountList.some(
        (option) => String(option.value) === String(selectedBeneficiary)
      )
    ) {
      return beneficiaryAccountList;
    }
    return [
      {
        label: String(
          paymentDetails?.beneficiaryAccountName ??
            paymentDetails?.beneficiaryBank ??
            paymentDetails?.beneficiaryAccount ??
            selectedBeneficiary
        ),
        value: String(selectedBeneficiary),
        currency: String(paymentDetails?.bankCurrency ?? ""),
      },
      ...beneficiaryAccountList,
    ];
  }, [beneficiaryAccountList, paymentDetails, selectedBeneficiary]);
  const canDownloadEximDepositSlip =
    isDepositSlipDownloadEnabled &&
    Number(pmtId) > 0 &&
    isEximBeneficiarySelected();
  const showLinerApprovalActions =
    isLiner &&
    pmtStatus.toUpperCase() !== "PAID" &&
    pmtStatus.toUpperCase() !== "AUTO_APPROVED" &&
    pmtStatus.toUpperCase() !== "CANCELLED" &&
    pmtStatus.toUpperCase() !== "REJECTED" &&
    pmtStatus !== "1" &&
    rbac.rbacDetails.paymentApproveReject === "Y";
  const showCustomerPaymentActions =
    pmtStatus !== "1" &&
    pmtStatus !== "Paid" &&
    !isLiner &&
    !isAttachmentMandate &&
    Boolean(pmtId) &&
    pmtStatus !== "Cancelled";
  const canEditLinerBeneficiary =
    isLiner && pymtConf.showBeneficiary === "Y" && !isPaidPayment;
  const canEditCustomerBeneficiary =
    isCustomerBeneficiaryAccountEditEnabled && !pmtId;
  const showTransferDate = useMemo(() => {
    return !!((pymtConf.showTransferDate === 'O' || pymtConf.showTransferDate === 'M') &&
      profileDetails.partnerType === "liner" &&
      pmtStatus?.toUpperCase() !== "PAID" &&
      pmtStatus?.toUpperCase() !== "AUTO_APPROVED" &&
      pmtStatus?.toUpperCase() !== "CANCELLED" &&
      pmtStatus?.toUpperCase() !== "REJECTED" &&
      pmtStatus !== "1" &&
      rbac.rbacDetails.paymentApproveReject === "Y"
    );
  }, [pymtConf.showTransferDate, profileDetails.partnerType, pmtStatus, rbac.rbacDetails.paymentApproveReject]);

  const linerRemarks = useSelector(
    (state: RootState) => state.blPayment.linerRemarks
  );

  const pymtId = useSelector((state: RootState) => state.blPayment.pmtId);

  // const fileName = useSelector((state: RootState) => state.blPayment.fileName);

  const resetValues = () => {
    setAdminRefNumber("");
    setBankRefNoLiner("");
  };
  const disableFieldsForNotSubmitted =
    isAttachmentMandate ||
      profileDetails?.partnerType === "liner" ||
      (matchPth && profileDetails?.partnerType !== "liner") ||
      (location.pathname.includes("blsliderpayment") &&
        paymentDetails &&
        pmtStatus?.toUpperCase() !== "SUBMITTED")
      ? true
      : false;
  useEffect(() => {
    if (
      location.pathname !== "/payment/new" &&
      !location.pathname.includes("unpaid/payment")
    ) {
      setBnkName(bnkNm);
      setAcName(accNo);
    }
  }, [bnkNm, accNo]);

  useEffect(() => {
    setPaymentCountry(invoiceCountry);
  }, [invoiceCountry]);


    useEffect(() => {
    if (paymentCountry !== null && paymentCountry != "" && selectedLinerId) {

      dispatch(
        getPymtModeOptions({
          partnerCountry: paymentCountry,
          selectedLinerId:profileDetails.partnerType === "liner"
              ? profileDetails?.partnerId
              : selectedLinerId,
          currency: pmtId ? selectedCcy : paymentCurrency
        })
      )
        .unwrap()
        .then((data) => {
          // if (!disableFields) {
          if (!disableFields) {
            const vanPayFlow =
              typeof window !== "undefined" &&
              new URLSearchParams(window.location.search).get("vanPay") === "1";
            dispatch(
              updatePaymentMode(vanPayFlow ? VAN_PAYMENT_MODE_ID : data[0].value)
            );
          }
        });
    }
  }, [paymentCountry, selectedLinerId, pmtId, selectedCcy, paymentCurrency, location.search]);

  useEffect(() => {
    //if (getUnprefixedPathname().split('/')[1] === 'blsliderpayment'){

    const searchParams = new URLSearchParams(window.location.search);
    const enkapStatus = searchParams.get('enkapStatus');
    // Skip payment details fetch for e-NKAP callback redirect
    const isEnkapCallback = enkapStatus && ['IN_PROGRESS', 'CONFIRMED', 'FAILED', 'CANCELED', 'CANCELLED'].includes(enkapStatus);

    // Also skip while the Payment.tsx polling loop is active. The polling loop
    // calls getPymtDetailsByReference which dispatches updatePymtData, setting
    // Redux pymtNo. That change re-fires this effect, which calls
    // getPymtDetailsByPymtNo, which dispatches updatePymtData again — creating
    // a cascade of 3x API calls. Suppress until polling has fully stopped and
    // the slider navigation has landed (enkapPollingActive will be false by then).
    if (enkapPollingActive) return;

    if (
      !isEnkapCallback && (
        isAttachmentMandate ||
        (location.pathname !== `${APP_PATH_PREFIX}/payment/new` &&
          !location.pathname.includes("unpaid/payment"))
      )
    ) {
      dispatch(
        getPymtDetailsByPymtNo({
          pymtId: isAttachmentMandate
            ? mandatePmtId
            : location.pathname.replace(APP_PATH_PREFIX, "").split("/")[1] === "blsliderpayment"
              ? location.pathname.replace(APP_PATH_PREFIX, "").split("/")[2]
              : pymtRefNo,
        })
      )
        .unwrap()
        .then((data) => {
          setPaymentDetails(data);
          setSelectedBeneficiary(
            String(
              data?.beneficiaryAccount ??
                data?.payorAccountId ??
                data?.beneficiaryBank ??
                ""
            )
          );
          setSelectedTransferDate(
            data?.transactionDate ? new Date(data.transactionDate) : null
          );
          setrejectionMsg(data?.linerRemarks ?? "")
          const country = data?.countryCode?.trim() ?? dataCountry;
          setPaymentCountry(country);

          const paidStatus = data?.amountPaidStatus;
          setAmountPaidType(
            paidStatus == "PARTIAL" || paidStatus == "FULL" ? paidStatus : null
          );
          setAmountPaidError(false);

          setPaymentProofMultiFiles([]);
          const popAttachments = data?.popAttachments;
          if (Array.isArray(popAttachments) && popAttachments.length > 0) {
            setPaymentProofMultiFiles(
              popAttachments.map((att: any) => ({
                rowNumber: crypto.randomUUID(),
                popAttId: att?.popAttId ?? undefined,
                docId: att?.docId ?? paymentProofDocId,
                fileName: att?.fileName ?? "",
                filePath: att?.filePath ?? "",
                tempFilePath: "",
                tempFileName: "",
                loading: 100,
                active: att?.active ?? "1",
              }))
            );
          }
        });
    }
    resetValues();
    // //} else if(location.pathname.includes('payment')){
    //   dispatch(getPymtDetailsByPymtNo({
    //     pymtNo: getUnprefixedPathname().split('/')[4]
    //   }));
    // }
  }, [pymtNo, location.pathname, enkapPollingActive]);
  const { showModal, handleNavigation, handleConfirm, handleCancel, handleBack } = useFormNavigationWarning({
    isChanged: isDirty,
    isEditable: true,
    onConfirm: _onCloseForm // or onBack, or your navigation function
  });

  const handleStayOnPage = () => {
    handleCancel();
  };

  const handleLeavePage = () => {
    onBack()
  };
  useEffect(() => {
    // settlement API for tolerence requirement (not in use right now)
    if (selectedLinerId && false) {
      dispatch(
        getCreditBalance({
          selectedLinerId:
            profileDetails.partnerType === "liner"
              ? profileDetails?.partnerId
              : selectedLinerId,
        })
      );
    }
    dispatch(paymentLoader(false));
  }, [selectedLinerId]);

  useEffect(() => {
    if (location.pathname.includes("new")) {
      setPmtId(0);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (disableFields) {
      pymtMode !== ""
        ? dispatch(updatePaymentMode(pymtMode))
        : dispatch(updatePaymentMode(pymtModeOptions[0].value));
      pymtNo !== ""
        ? setInputValue(
            isSplitChequeReference
              ? paymentDetails?.bankRefNo ?? ""
              : pymtNo
          )
        : setInputValue("");
      pymtAmt !== "" ? setPaymentAmount(pymtAmt) : setPaymentAmount("");
      const sliderFinalCcy = showFinalCurrency && resolvedFinalCurr;
      sliderFinalCcy
        ? setSelectedCcy(sliderFinalCcy)
        : pymtCurr !== ""
          ? setSelectedCcy(pymtCurr)
          : setSelectedCcy("USD");
      pymtId ? setPmtId(pymtId) : setPmtId(0);
      setRadioValue(radioVal);
      if (payorAccountId) {
        setSelected(payorAccountId);
      } else {
        setSelected(bankData[0]?.value);
        setBnkName(bankData[0]?.bankName || "");
        setAcName(bankData[0]?.accountNo || "");
      }
    } else {
      setSelected(bankData[0]?.value);
      setBnkName(bankData[0]?.bankName || "");
      setAcName(bankData[0]?.accountNo || "");

      //setRadioValue("auto");
    }
  }, [pymtNo, pymtId, bankData, pymtCurr, showFinalCurrency, paymentDetails]);

  const handleDuplicacy = () => {
    var newSelectedData: any = [];

    if (lastEndpoint == "instructionpayment") {
      const desiredInstructions = ["780", "102", "103", "381"];

      newSelectedData = tabledata
        .filter((item: any) => desiredInstructions.includes(item.instructionId))
        .map((item: any) => ({
          invId: item.docId,
          invNo: item.documentNumber,
        }));
    } else {
      newSelectedData = filteredselectedAmount?.map((item: any) => ({
        invId: item.invID,
        invNo: item.id,
        invAmt: item.amount,
      }));
    }
    const state = {
      paymentMode: paymentMode,
      inputValue: inputValue,
    };

    dispatch(
      addInvoiceToExistingPayment({
        invoices: newSelectedData,
        pmtId: duplicayID,
        paymentFundings: [],
        paymentMode: paymentMode,
        paymentRefNo: isCustomerChequeReference ? pymtNo : inputValue,
        currency: filteredselectedAmount?.[0]?.invcurr || "USD",
        payorAccountId: pymtMode == PaymentMode.BankTransfer ? selected : "",
        beneficiaryAccount: isCustomerBeneficiaryAccountEditEnabled && selectedBeneficiary
          ? Number(selectedBeneficiary)
          : undefined,
        linerId: linerId,
        pmtAmount: amountDetails,
        bankRefNo: radioValue != "auto" ? inputValue : "",
        pmtProofAtt: "",
        paymentProofFileName:
          paymentProofMultiFiles?.find((f) => f.active == "1")?.fileName ?? "",
        serverFilePath:
          paymentProofMultiFiles?.find((f) => f.active == "1")?.tempFilePath ?? null,
        tempFileName:
          paymentProofMultiFiles?.find((f) => f.active == "1")?.tempFileName ?? null,
      })
    );

    setTimeout(() => {
      navigate(`${APP_PATH_PREFIX}/payment`);
      dispatch(updateSelectedRowsInvoice([]));
      dispatch(updateSelectedAmount([]));
    }, 500);
  };

  const [showConfirmMsg, setShowConfirmMsg] = useState(false);
  const checkValidationAndUpdate = async () => {
    if (!validateAmountPaidBeforeSubmit()) {
      setLoading(false);
      return;
    }
    var filteredArray: any = [];

    const duplicateFlag = await dispatch(
      checkDuplicateReferenceNoByPymtId({
        inputValue,
        selectedCcy: pymtCurr,
        selectedPymtId: pymtId,
        pymtAmt: formatNumber(paymentAmount),
      })
    );

    if (duplicateFlag?.payload == true) {
      if (editPayment) {
        if (pmtReftabledata.length == 0) {
          setShowConfirmMsg(true);
        } else if (pmtNumberdata > pmtReftabledata) {
          setShowConfirmMsg(true);
        } else {
          handleUpdate();
        }
      }
    } else {
      setLoading(false);
      if (duplicateFlag?.payload != undefined) {
        setShowEditDuplicacy(true);
        setpaymentRefFocus(false);
        //setduplicayID(duplicateFlag.payload);
        seteditDuplicayMsg(Object.values(duplicateFlag?.payload)[0]);
        if (
          Object.values(duplicateFlag?.payload)[0] ==
          "Payment Reference No. already exists."
        ) {
          setMethodName("handleUpdate");
        }
      }
    }
  };

  const handleUpdate = () => {
    if (!validateAmountPaidBeforeSubmit()) {
      setLoading(false);
      return;
    }
    var filteredArray: any = [];
    invoiceDashboardData.result?.forEach((d: any, i: any) => {
      if (
        paymentData.pmtNumberdata?.map?.((v: any) => v.invNo).includes(d.invno)
      )
        filteredArray.push(d.pmtReference);
    });

    dispatch(
      editBankPymtRefNo({
        invoices: pmtReftabledata.map((item: any) => ({
          invId: item.invid ? item.invid : item.invId,
          invNo: item.invNo,
          invAmt: item.invAmt,
        })),

        pmtId: pmtId,
        paymentFundings: [],
        paymentMode: paymentMode,
        paymentRefNo: isCustomerChequeReference ? pymtNo : inputValue,
        currency: selectedCcy,
        payorAccountId: pymtMode == PaymentMode.BankTransfer ? selected : "",
        beneficiaryAccount: isCustomerBeneficiaryAccountEditEnabled && selectedBeneficiary
          ? Number(selectedBeneficiary)
          : undefined,
        linerId: linerId,
        pmtAmount: pmtReftabledata.reduce(
          (sum: any, obj: { invAmt: string }) =>
            sum +
            (typeof obj.invAmt === "string"
              ? parseFloat(obj.invAmt)
              : obj.invAmt),
          0
        ),
        bankRefNo: radioValue != "auto" ? inputValue : "",
        pmtProofAtt: "",
        paymentProofFileName:
          paymentProofMultiFiles?.find((f) => f.active == "1")?.fileName ?? "",
        refType: paymentMode == PaymentMode.Cheque ? 3 : radioValue === "auto" ? 1 : 2,
        serverFilePath:
          paymentProofMultiFiles?.find((f) => f.active == "1")?.tempFilePath ?? null,
        tempFileName:
          paymentProofMultiFiles?.find((f) => f.active == "1")?.tempFileName ?? null,
      })
    )
      .unwrap()
      .then((response: any) => {
        if (response !== "") {
          setTimeout(() => {
            if (window.location.pathname.includes("blsliderpayment")) {
              navigate(`${APP_PATH_PREFIX}/payment`);
              dispatch(updateSelectedRowsInvoice([]));
              dispatch(updateSelectedAmount([]));
            } else {
              navigate(`${APP_PATH_PREFIX}/home`);
            }
          }, 1500);
        }
      });
    // setTimeout(() => {
    //   navigate(-1);
    // }, 500);
  };
  const initialOptions = {
    clientId:
      "AV1xxFp72k264HFbt5pwbKcj31pP3oCX-8qJZYuOvRL4wYhum6JdpXZRlfJKeHcuFJ2RwuszDuCcePWi",
    currency: "USD",
    intent: "capture",
  };
  const handleSubmitWithDuplicate = async () => {
    if (!validateAmountPaidBeforeSubmit()) {
      return;
    }
    var newSelectedData = [];

    if (lastEndpoint == "instructionpayment") {
      const desiredInstructions = ["780", "102", "103", "381"];

      newSelectedData = tabledata
        .filter((item: any) => desiredInstructions.includes(item.instructionId))
        .map((item: any) => ({
          invId: item.docId,
          invNo: item.documentNumber,
        }));
    } else {
      newSelectedData = filteredselectedAmount?.map((item: any) => ({
        invId: item.invID,
        invNo: item.id,
        blId:  item.blId ?? item.blid ?? item.bl_id,
      }));
    }

    const newpaymentFund = selecteCredData?.map(
      (item: { paymentFundingId: any }) => ({
        paymentFundingId: item.paymentFundingId,
      })
    );
    const tooltipContent = filteredselectedAmount.map(
      (item: any) => `● ${item.id} `
    );

    const newPayload = {
      invoices: newSelectedData,
      paymentFundings:
        paymentMode == PaymentMode.BankTransfer || paymentMode == VAN_PAYMENT_MODE_ID
          ? []
          : newpaymentFund,
      paymentMode: paymentMode,
      paymentRefNo: pmtRefNo,
      currency: filteredselectedAmount?.[0]?.invcurr || "USD",
      payorAccountId:
        pymtMode == PaymentMode.BankTransfer ? selected : "",
      beneficiaryAccount:
        isCustomerBeneficiaryAccountEditEnabled && selectedBeneficiary
          ? Number(selectedBeneficiary)
          : undefined,
      linerId: linerId,
      pmtAmount: amountDetails,
      bankRefNo: isCustomerChequeReference ? inputValue : "",
      pmtProofAtt: "",
      popAttachments: buildPopAttachments(),
      ...getAmountPaidPayload(),
    };

    dispatch(submitPaymentBanks(newPayload));
  };

  /**
   * Single-call e-nkap checkout handler (Scenario 3 & 4).
   *
   * Replaces the old two-step flow of submitPaymentBanks → initiateEnkapPayment.
   * Calls a single atomic backend endpoint that:
   *   1. Validates invoices
   *   2. Creates the ODeX payment record (Gateway_Initiated)
   *   3. Creates the payment-gateway-v2 session
   *   4. Places the e-nkap order and gets the redirect URL
   *
   * On any backend failure the entire operation is rolled back — no locked
   * invoice or orphaned payment record is left, and the customer can retry.
   *
   * @param selectedInvoices - list of { invId, invNo, blId } items to pay
   */
  const handleEnkapCheckout = async (
    selectedInvoices: { invId: number; invNo: string; blId: number; invAmt: number }[]
  ) => {
    const rawGatewayId = pymtConf?.gatewayId ?? pymtConf?.gateway_id;
    const gatewayId    = rawGatewayId != null ? Number(rawGatewayId) : NaN;

    if (!gatewayId || isNaN(gatewayId)) {
      toast.error(
        "e-nkap payment gateway is not configured. Please contact support.",
        { theme: "colored", autoClose: 10000 }
      );
      dispatch(resetPaymentLoaders());
      return;
    }

    const invoiceAmt    = Number(amountDetails);
    const serviceCharge = Number(platformfee) || 0;
    const totalAmount   = invoiceAmt + serviceCharge;

    try {
      const result = await dispatch(
        initiateEnkapCheckout({
          invoices:    selectedInvoices,
          amount:      totalAmount,
          currency:    selectedInvoiceCurrency || "XAF",
          linerId:     Number(linerId),
          country:     paymentCountry || "",
          gatewayId,
          userId:      String(profileDetails?.userId ?? ""),
          userEmailId: profileDetails?.email ?? "",
        })
      ).unwrap();

      if (result?.success && result?.redirectUrl) {
        dispatch(resetPaymentLoaders());
        // Replace the checkout form URL in the browser history stack with the
        // payment dashboard so the Back button from the e-nkap page lands on
        // the dashboard, not back on the pre-filled checkout form.
        // NOTE: pushState to a cross-origin URL (e-nkap) is a SecurityError —
        // we only replaceState to our own origin here.
        window.history.replaceState(null, '', `${APP_PATH_PREFIX}/payment`);
        // Scenario 4: redirect customer to e-nkap in same tab.
        window.location.href = result.redirectUrl;
      } else {
        toast.error(
          result?.message ?? "Failed to initiate e-nkap payment. Please try again.",
          { theme: "colored" }
        );
        dispatch(resetPaymentLoaders());
      }
    } catch (enkapError: any) {
      // Show API error message in toast
      const errorMessage = enkapError?.payload?.message || enkapError?.message || "Failed to initiate e-nkap payment. Please try again.";
      toast.error(errorMessage, { theme: "colored" });
      dispatch(resetPaymentLoaders());
    }
  };

  const handleSubmit = async () => {
    setDepositSlipPaymentId(null);
    if (!validateAmountPaidBeforeSubmit()) {
      return;
    }
    // navigate(-1);
    /// dispatch(updateSelectedBlListMultiPayTable({}));
    // dispatch(updateSelectedAmount([]));
    // dispatch(updateSelectedRowsInvoice([]));

    var newSelectedData = [];

    if (matchPath(`${APP_PATH_PREFIX}/payment/addInvoice/invoicePayment`, location.pathname)) {
      newSelectedData = standaloneInvoiceList.map(
        (invoice: StandaloneInvoiceDetails) => ({
          invId: invoice.invoiceId,
          invNo: invoice.invoiceNumber ?? invoice.invoiceNo,
          amount: Number(invoice.invoiceAmount ?? 0),
        })
      );
    } else if (location.pathname.includes("unpaid")) {
      newSelectedData = newUnpaidData.map((invoice: any) => ({
        invId: invoice.invID,
        invNo: invoice.id,
        amount: Number(invoice.amount ?? 0),
      }));
    } else if (lastEndpoint == "instructionpayment") {
      const desiredInstructions = ["780", "102", "103", "381"];

      newSelectedData = tabledata
        .filter((item: any) => desiredInstructions.includes(item.instructionId))
        .map((item: any) => ({
          invId: item.docId,
          invNo: item.documentNumber,
          amount: Number(item.amount ?? 0),
        }));
    } else {
      newSelectedData = filteredselectedAmount?.map((item: any) => ({
        invId: item.invID,
        invNo: item.id,
        blId:  item.blId ?? item.blid ?? item.bl_id,
        amount: Number(item.amount ?? 0),
      }));
    }
    const newpaymentFund = selecteCredData?.map(
      (item: {
        paymentFundingId: any;
        //unAllocatedAmount: any;
        //allocatedAmount: any;
      }) => ({
        paymentFundingId: item.paymentFundingId,
        /*    allocatedAmt:item.allocatedAmount, */
        //allocatedAmt: String(parseInt(item.allocatedAmount) + parseInt(amountDetails)),
      })
    );
    const tooltipContent = filteredselectedAmount.map(
      (item: any) => `● ${item.id} `
    );
    let testdata = newSelectedData.filter((v: any) =>
      paycargoInvoiceList.map((item: any) => item.invNo).includes(v.invNo)
    );

    const newPayload = {
      invoices:
        paymentMode == PaymentMode.PayCargo
          ? newSelectedData.filter((v: any) =>
            paycargoInvoiceList.some((item: any) => v.invNo == item.invNo)
          )
          : newSelectedData,
      paymentFundings:
        paymentMode == PaymentMode.BankTransfer || paymentMode == VAN_PAYMENT_MODE_ID
          ? []
          : newpaymentFund,
      paymentMode: paymentMode,
      paymentRefNo: isCustomerChequeReference
        ? pmtRefNo
        : paymentMode == PaymentMode.Wallet
          ? ""
          : inputValue,
      currency: selectedInvoiceCurrency || "USD",
      ...(showFinalCurrency && resolvedFinalCurr
        ? { finalCurrency: resolvedFinalCurr }
        : {}),
      payorAccountId:
        pymtMode == PaymentMode.BankTransfer ? selected : "",
      beneficiaryAccount:
        isCustomerBeneficiaryAccountEditEnabled && selectedBeneficiary
          ? Number(selectedBeneficiary)
          : undefined,
      linerId: linerId,
      pmtAmount:
        paymentMode == PaymentMode.PayCargo
          ? paycargoInvoiceList
            .map((i: any) => Number(i.invAmt))
            .reduce((partialSum: any, a: any) => partialSum + a, 0)
          : amountDetails,
      localAmount: multiCurrencyAllow
        ? (location.pathname.includes("unpaid")
            ? filteredselectedAmount
            : selectedAmount
          )
            .map((item: any) => item?.localamount)
            .reduce((partialSum: any, a: any) => partialSum + a, 0)
        : "",
      localCcy: multiCurrencyAllow
        ? location.pathname.includes("unpaid")
          ? filteredselectedAmount[0]?.localccy ?? ""
          : selectedAmount[0]?.localccy
        : "",
      bankRefNo: isCustomerChequeReference ? inputValue : "",
      pmtProofAtt: "",
      refType: paymentMode == PaymentMode.Cheque ? 3 : radioValue === "auto" ? 1 : 2,
      integrationResponse: paymentMode == PaymentMode.PayCargo ? integrationResponse : "",
      ...(paymentMode == PaymentMode.PayCargo
        ? {
            paymentProofFileName:
              paymentProofMultiFiles?.find((f) => f.active == "1")?.fileName ?? "",
            serverFilePath:
              paymentProofMultiFiles?.find((f) => f.active == "1")?.tempFilePath ??
              null,
            tempFileName:
              paymentProofMultiFiles?.find((f) => f.active == "1")?.tempFileName ??
              null,
          }
        : {
            popAttachments: buildPopAttachments(),
            ...getAmountPaidPayload(),
          }),
    };

    console.log(newPayload,"newPayload1")

    let result : any;
    let keepPaymentPageForDepositSlip = false;
    {
      if (
        window.location.pathname === `${APP_PATH_PREFIX}/payment/new` ||
        location.pathname.includes("unpaid") ||
        location.pathname.includes("addInvoice")
      ) {
        const duplicateFlag = await dispatch(
          checkDuplicateReferenceNo({
            inputValue,
            selectedCcy: paymentCurrency || "USD",
          })
        );

        if (duplicateFlag.payload == true) {
          if (tooltipContent?.length > 0) {
            if (paymentMode == PaymentMode.PayCargo) {
              dispatch(submitAutoPayment(newPayload))
            } else if (paymentMode == PaymentMode.MtnMobileMoney) {
              // e-nkap (MTN Mobile Money) — single atomic checkout call.
              // Does NOT call submitPaymentBanks first. The backend endpoint
              // creates the payment record, session and e-nkap order atomically
              // and rolls back everything on failure.
              await handleEnkapCheckout(
                newSelectedData.map((inv: any) => ({
                  invId: inv.invId,
                  invNo: inv.invNo,
                  blId:  inv.blId ?? inv.invId, // blId populated by newSelectedData mapping
                  invAmt: Number(inv.invAmt ?? inv.amount ?? 0),
                }))
              );
              return; // redirect handled inside handleEnkapCheckout
            } else {
              result = await dispatch(submitPaymentBanks(newPayload)).unwrap();
              keepPaymentPageForDepositSlip = makeEximDepositSlipAvailable(result);
              if (paymentMode == VAN_PAYMENT_MODE_ID) {
                const payable = parsePayableAmountForVan(amountDetails);
                if (payable > 0) dispatch(subtractVanPayableAmount(payable));
              }
            }
          } else {
             dispatch(
              submitPaymentAddFund({
                pmtReference: inputValue,
                pmtMode: paymentMode,
                pmtAmount: amountDetails,
                currency: selectedCcy,
                pmtProofAtt: "",
                payorBankName: bnkName,
                payorAccountId: selected,
                pmtStatus: "2",
                pmtType: "ADD FUNDS ",
                linerId: linerId,
                // selectedLinerId: selectedLinerId,
              })
            )
              .unwrap()
              .then((response: any) => {
                if (response.data.statusCode === 400) {
                  toast.dark(response.data.message);
                } else {
                  toast.dark(response.data.message);
                }
              });
          }
          if (!keepPaymentPageForDepositSlip && location.pathname.includes("unpaid")) {
            setTimeout(() => {
              navigate(location.pathname.replace("unpaid/payment", "unpaid"));
            }, 2000);
          } else if (!keepPaymentPageForDepositSlip && result?.mode == PaymentMode.QRCode && radioValue === "auto" && result?.success === "true") {
            const pmtId = AESEncrypt(result?.pmtId)
            setTimeout(() => {
              dispatch(resetPaymentLoaders());
              navigate(`${APP_PATH_PREFIX}/blsliderpayment/${pmtId}`);
            }, 2000);
          } else if (!keepPaymentPageForDepositSlip) {
            navigate(`${APP_PATH_PREFIX}/payment`);
          }
          setTimeout(() => {
            dispatch(updateDashbaordRefresh(true));
            if (!keepPaymentPageForDepositSlip) {
              dispatch(updateSelectedRowsInvoice([]));
              dispatch(updateSelectedAmount([]));
            }
          }, 1500);
        } else {
          if (duplicateFlag.payload != undefined) {
            setshowDuplicacy(true);
            setpaymentRefFocus(false);
            //setduplicayID(duplicateFlag.payload);
            setduplicayID(Object.keys(duplicateFlag?.payload)[0]);
            setduplicayMsg(Object.values(duplicateFlag?.payload)[0]);
          }
        }
      } else {
        // e-nkap (MTN Mobile Money) — bypass submitPaymentBanks entirely.
        // The new single atomic endpoint handles everything.
        if (paymentMode == PaymentMode.MtnMobileMoney) {
          await handleEnkapCheckout(
            newSelectedData.map((inv: any) => ({
              invId: inv.invId,
              invNo: inv.invNo,
              blId:  inv.blId ?? inv.invId,
              invAmt: Number(inv.invAmt ?? inv.amount ?? 0),
            }))
          );
          return;
        }

        result = await dispatch(submitPaymentBanks(newPayload)).unwrap();
        keepPaymentPageForDepositSlip = makeEximDepositSlipAvailable(result);
        if (paymentMode == VAN_PAYMENT_MODE_ID) {
          const payable = parsePayableAmountForVan(amountDetails);
          if (payable > 0) dispatch(subtractVanPayableAmount(payable));
        }
        if (!keepPaymentPageForDepositSlip && location.pathname.includes("unpaid")) {
          setTimeout(() => {
            navigate(location.pathname.replace("unpaid/payment", "unpaid"));
          }, 2000);
        } else if(!keepPaymentPageForDepositSlip && result?.mode == PaymentMode.QRCode && radioValue === "auto" && result?.success === "true"){
          const pmtId = AESEncrypt(result?.pmtId)
          setTimeout(() => {
              dispatch(resetPaymentLoaders());
            navigate(`${APP_PATH_PREFIX}/blsliderpayment/${pmtId}`);
          }, 2000);
        }
        else if (!keepPaymentPageForDepositSlip) {
          navigate(`${APP_PATH_PREFIX}/payment`);
          dispatch(updateDashbaordRefresh(true));
          dispatch(updateSelectedRowsInvoice([]));
          dispatch(updateSelectedAmount([]));
        }
      }
    }
    {
      if (paymentMode == PaymentMode.PayCargo) {
        let failedInvData = newSelectedData.filter((v: any) =>
          paycargoInvoiceList.some((item: any) => v.invNo != item.invNo)
        );

        // if (failedInvData.length > 0) {
        //   toast.dark(
        //     `${JSON.stringify(
        //       failedInvData.map((v: any) => v.invNo)
        //     )} payment has not been processed.`
        //   );
        // }
      }
    }

    // if(paymentMode == String(PaymentMode.BankTransfer) ){

    //   const newSelectedData = selecteData?.map(item => ({
    //     invId: item.id,
    //     invNo: item.number
    //   }));

    //   const match = acName.match(/\d+/);
    //   const extractedNumber = match[0];

    //   const payload = {
    //     invoiceData: newSelectedData,
    //     paymentMode: paymentMode,
    //     bankName: bnkName,
    //     accNo: extractedNumber,
    //     payorAccountId: "1",
    //     paymentRefNo: "PUS1234567",
    //     pmtProofAttachment: "docPath of Upload",
    //     paymentAmt: amountDetails,
    //     currency: "USD"
    //   }

    //   const newpaymentFund = selecteCredData?.map((item: { paymentFundingId: any; allocatedAmount: any; pmtAmount: any; }) => ({
    //     paymentFundingId : item.paymentFundingId,
    //     allocatedAmt:item.allocatedAmount,
    //     pmtAmount:item.pmtAmount
    //   }));

    //   const newPayload = {
    //     invoices: newSelectedData,
    //     paymentFundings:paymentMode == String(PaymentMode.BankTransfer) ? [] : newpaymentFund,
    //     paymentMode: paymentMode,
    //     paymentRefNo: "doodo",
    //     currency: "USD"
    //   };

    //   dispatch(submitPaymentBanks(payload));
    // }

    // if(paymentMode == String(PaymentMode.Wallet)){

    //   const newSelectedData = selecteData?.map(item => ({
    //     invId:item.id,
    //     InvNo: item.number,
    //     InvCurrency: "USD"
    //   }));

    //   const newpaymentFund = selecteData?.map(item => ({
    //     paymentFundingId : item.paymentFundingId,
    //     bankName : 23,
    //     paymentAmt : item.paymentAmt,
    //     paymentCurrancy : "USD"
    //   }));

    //   const payload  = {
    //     invoiceData: newSelectedData,
    //     paymentFund: newpaymentFund,
    //     paymentMode: paymentMode,
    //     paymentRefNo: "",
    //     paymentAmt: amountDetails,
    //     currency: "USD"
    //   }
    //   dispatch(submitPaymentBanks(payload));
    // }
    /*  setTimeout(() => {
      navigate(`${APP_PATH_PREFIX}/payment`);
    }, 500); */
  };

  const [bankRefNoLiner, setBankRefNoLiner] = useState("");
  const [adminRefNumber, setAdminRefNumber] = useState("");
  const [selectedTotal, setselectedTotal] = useState("");

  const selectedCreditAmount = selecteCredData
    .map((i: any) => Number(i.unAllocatedAmount))
    .reduce((partialSum: any, a: any) => partialSum + a, 0);
  const totalCreditAmount = creditBalanceList
    ?.map((i: any) => Number(i.unAllocatedAmount))
    .reduce((partialSum: any, a: any) => partialSum + a, 0);

  useEffect(() => {
    if (
      selectedCreditAmount > 0 &&
      amountDetails > 0 &&
      selectedCreditAmount > amountDetails
    ) {
      // toast.error('Selected Invoice amount is greater than the Credit Balance');
    }
  }, [selecteCredData, amountDetails]);

  // const formatNumber = (value: string): string => {
  //   const parsedValue = parseFloat(value);
  //   if (isNaN(parsedValue)) return value; // Return the original value if it's not a valid number

  //   const roundedValue = parseFloat(parsedValue.toFixed(2)); // Round to two decimal places
  //   const [integerPart, decimalPart] = roundedValue.toString().split('.');
  //   const formattedInteger = parseInt(integerPart, 10).toLocaleString();
  //   const formattedDecimal = decimalPart ? `.${decimalPart}` : '';
  //   return `${formattedInteger}${formattedDecimal}`;
  // };

  const formatNumber = useAmountFormatter(selectedCcy);
  //const [editPayment, setEditPayment] = useState(false);

  const pmtNumberdataCount = useSelector(
    (state: RootState) => state.paymentBlPayment.pmtNumberdata
  );

 // console.log(rejectionMsg, linerRemarks, '<<rejectionMsg')

  const transactionDetailsCols: IDataTableColumn[] = [
    {
      accessor: "transaction_date",
      Header: "Transaction Date",
      Cell: (rowData: any) => {
        const { transaction_date } = rowData.row.original;
        const formattedDate = new Date(transaction_date).toLocaleString();
        return (
          <span data-toggle="tooltip" title={formattedDate}>
            {formattedDate}
          </span>
        );
      },
      minWidth: 150,
      width: 150,
      maxWidth: 250,
    },
    {
      accessor: "payment_ref_no",
      Header: "Payment Ref No",

      Cell: (rowData: any) => {
        const { payment_ref_no } = rowData.row.original;
        return (
          <span data-toggle="tooltip" title={payment_ref_no}>
            {payment_ref_no}
          </span>
        );
      },
      minWidth: 130,
      width: 130,
      maxWidth: 150,
    },
    {
      accessor: "bank_ref_no",
      Header: "Bank Ref No",
      Cell: (rowData: any) => {
        const { bank_ref_no } = rowData.row.original;
        const copyText = () => {
          navigator.clipboard.writeText(bank_ref_no);
          toast("Copied to clipboard");
          setBankRefNoLiner(bank_ref_no);
        };
        return (
          <span
            data-toggle="tooltip"
            title={bank_ref_no}
            onClick={copyText}
            className="mx-2 link-primary "
            style={{ cursor: "pointer", fontWeight: 550 }}
          >
            {bank_ref_no}
          </span>
        );
      },
      minWidth: 150,
      width: 150,
      maxWidth: 170,
    },
    {
      accessor: "amt",
      Header: "Amount",
      Cell: (rowData: any) => {
        const { amt } = rowData.row.original;
        return (
          <span data-toggle="tooltip" title={amt}>
            {amt}
          </span>
        );
      },
      minWidth: 90,
      width: 90,
      maxWidth: 110,
    },

    {
      accessor: "ccy",
      Header: "CCY",
      Cell: (rowData: any) => {
        const { ccy } = rowData.row.original;
        return (
          <span data-toggle="tooltip" title={ccy}>
            {ccy}
          </span>
        );
      },
      minWidth: 55,
      width: 55,
      maxWidth: 55,
    },
    {
      accessor: "payorName",
      Header: "Payor Name",
      Cell: (rowData: any) => {
        const { payorName } = rowData.row.original;
        return (
          <span data-toggle="tooltip" title={payorName}>
            {payorName}
          </span>
        );
      },
      minWidth: 120,
      width: 120,
      maxWidth: 170,
    },

    {
      accessor: "remarks",
      Header: "Remarks",
      Cell: (rowData: any) => {
        const { remarks } = rowData.row.original;
        return (
          <span data-toggle="tooltip" title={remarks}>
            {remarks}
          </span>
        );
      },
      minWidth: 350,
      width: 350,
      maxWidth: 350,
    },
  ];
  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (showPaymentProofMultiAttachment) return;
    if (e.target.files) {
      const file = e.target.files[0];
      dispatch(setDirty());
      const allowedExtensions = [".pdf", ".png", ".jpeg", ".jpg"];
      const maxFileSize = 5 * 1024 * 1024; // 5MB in bytes

      if (file.size > maxFileSize) {
        toast.error(
          `File size is greater than ${Math.round(
            maxFileSize / 1000000
          )}MB. Please upload file below ${Math.round(maxFileSize / 1000000)}MB`
        );
        e.target.value = "";
        return;
      }
      if (file.name.length > 60) {
        toast.error(t("resource_message:fileNameLimit60").toString());
        e.target.value = "";
        return;
      }

      let fileExt = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();

      if (!allowedExtensions.includes(fileExt)) {
        toast.error("Please upload only PDF, PNG, JPEG, or JPG files.");
        e.target.value = "";
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      const existingProof = paymentProofMultiFiles?.find((f) => f.active == "1");

      const newProofFile: FileUploadResult = {
        rowNumber: existingProof?.rowNumber ?? crypto.randomUUID(),
        popAttId: existingProof?.popAttId,
        docId: existingProof?.docId ?? paymentProofDocId,
        fileName: file.name,
        filePath: "",
        tempFilePath: "",
        tempFileName: "",
        loading: 0,
        active: "1",
      };

      try {
        setPaymentProofMultiFiles((prev) =>
          existingProof?.rowNumber != null &&
          prev.some((f) => f.rowNumber == existingProof.rowNumber)
            ? prev.map((f) =>
                f.rowNumber == existingProof.rowNumber ? { ...f, ...newProofFile } : f
              )
            : [...prev, newProofFile]
        );
        axiosInstance
          .post("/api/edo-rest-v1/v1/view/file", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress(progressEvent) {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / (progressEvent.total ?? 1)
              );
              handlePaymentProofMultiPending(
                newProofFile.rowNumber,
                percentCompleted
              );
            },
          })
          .then((response) => {
            if (!response?.data?.path || !response?.data?.tempFileName)
              throw new Error("upload error!");
            handlePaymentProofMultiFulfilled(
              newProofFile.rowNumber,
              newProofFile.fileName,
              response.data.path,
              response.data.tempFileName
            );
          })
          .catch(() => {
            setPaymentProofMultiFiles([]);
            e.target.value = "";
          });
      } catch (err) {
        console.error("File Upload Error: ", err);
        e.target.value = "";
        setPaymentProofMultiFiles([]);
      }
    }
  };

  /*   const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const file = e.target.files[0];

      if (file.size > attachedFileSize) {
        toast.error(
          `File size is greater than ${Math.round(
            attachedFileSize / 1000000
          )}MB. Please upload file below ${Math.round(
            attachedFileSize / 1000000
          )}MB`
        );
        e.target.value = "";
        return;
      }
      if(file.name.length > 70){
        toast.error(t("resource_message:fileNameLimit60").toString());
        e.target.value = "";
        return;
      }

      let fileExt = file.name.slice(-4);

      if (fileExt.toLowerCase() != ".pdf") {
        toast.error("Please upload Only PDF File");
        e.target.value = "";
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      try {
        setPaymentProofFileName(file.name);
        setSelectedFileServerPath([null, null]);
        setLoadingFileState(0);
        const resp = axiosInstance
          .post("/api/edo-rest-v1/v1/view/file", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress(progressEvent) {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / (progressEvent.total ?? 1)
              );
              setLoadingFileState(percentCompleted);
            },
          })
          .then((response) => {
            setLoadingFileState(100);
            if (!response?.data?.path || !response?.data?.tempFileName)
              throw new Error("upload error!");
            setSelectedFileServerPath([
              response.data.path,
              response.data.tempFileName,
            ]);
          })
          .catch(() => {
            setLoadingFileState(-1);
            setPaymentProofFileName("");
            e.target.value = "";
          });
      } catch (err) {
        console.error("File Upload Error: ", err);
        e.target.value = "";
        setLoadingFileState(-1);
        setPaymentProofFileName("");
      }
    }
    // const buffer = await file.arrayBuffer();
    // const bytes = new Uint8Array(buffer);
    // setByteArr(bytes.toString());
  }; */

  // const [disableSubmitButton, setDisableSubmitButton] = useState(false);

  // useEffect(() => {
  //   if (+selectedTotal < 0) {
  //     setDisableSubmitButton(true);
  //   } else {
  //     setDisableSubmitButton(false);
  //   }
  // }, [selectedTotal]);


  const checkRestrictedKeywords = async (value: string): Promise<string | null> => {
  try {
    let result;
    if(linerId && paymentCountry && value){
      result = await dispatch(checkPaymentReferenceIsValid({
      linerId,
      countryCode: paymentCountry,
      pmtRef: value
    })).unwrap();
  }

    if (result?.success === "false") {
      return result.message || "Invalid reference keyword.";
    }

    return null;
  } catch (error) {
    console.error("Validation failed:", error);
    return "Validation could not be completed. Please try again.";
  }
};

  const handleInputBlur = async (e: any) => {
    let cleanedValue = "";

    if (inputValue != "" && paymentMode == PaymentMode.Cheque) {

      // e.target.value.padStart(6,'0') /* .replace(/ /g, '') */
      cleanedValue = e.target.value
        .replace(/^0+/, "")
        .replace(/[^0-9]/g, "")
        .replace(/\s+/g, " ")
        .trim()

    } else {
      // setInputValue(
      //   // e.target.value.padStart(6,'0') /* .replace(/ /g, '') */
      //   e.target.value.trim()
      // );
      cleanedValue = e.target.value.trim();
    }
    const errorMessage = await  checkRestrictedKeywords(cleanedValue);
    if (errorMessage) {
      toast.error(errorMessage);
      setInputValue("");
      return;
    }


    setInputValue(cleanedValue);
    handleBankRefBlur(e)
  };


  const handleInputChange = (e: any) => {
    const value = e.target.value;
    setInputValue(value);

    let cleanedValue = "";

    if (value !== "" && paymentMode == PaymentMode.Cheque) {
      cleanedValue = value
        .replace(/^0+/, "")
        .replace(/[^0-9]/g, "")
        .replace(/\s+/g, " ")
        .trim();
    } else {
      cleanedValue = value.trim();
    }




  };






  //   let cleanedValue = "";

  //   if (inputValue !== "" && paymentMode === PaymentMode.Cheque) {
  //     cleanedValue = e.target.value
  //       .replace(/^0+/, "")
  //       .replace(/[^0-9]/g, "")
  //       .replace(/\s+/g, " ")
  //       .trim();
  //   } else {
  //     cleanedValue = e.target.value.trim();
  //   }

  //   setInputValue(cleanedValue);


  //   const min = pymtConf.minLength;
  //   const max = pymtConf.maxLength;

  //   if (cleanedValue.length < min || cleanedValue.length > max) {
  //     setInputError(`Input must be between ${min} and ${max} characters.`);
  //   } else {
  //     setInputError("");
  //   }

  //   handleBankRefBlur(e);
  // };


  const handleApprovePayment = () => {
    if (isApproveDisabledByPartialPop) {
      toast.error(
        "This payment is marked as Partial Paid and cannot be approved."
      );
      return;
    }
    const isPaidFromSAP = paymentDetails.pmtStatus === "Paid_From_SAP";
    let selectedBankCurrency=null;
    if(selectedBeneficiary){
      selectedBankCurrency = beneficiaryAccountOptions?.find(item => item.value == selectedBeneficiary)?.currency;
    }
    const payload = {
       paymentRef: pymtNo,
      pmtId: pymtId,
      bnkRefNo: bankRefNoLiner,
      currency: pymtCurr || selectedInvoiceCurrency || "USD",
      showFinalCurrency,
      ...(showFinalCurrency && resolvedFinalCurr
        ? {
            finalCurrency: resolvedFinalCurr,
          }
        : {}),
      adminRefNumber: adminRefNumber,
      amount: paymentAmount,
      linerId: linerId,
      country: paymentCountry,
      paymentSubmittedByEmail:paymentDetails?.userEmailId,
      remarks: rejectionMsg,
      beneficiaryBank: selectedBeneficiary ?? "",
      bankCurrency: selectedBankCurrency ?? "",
      paymentTransferDate: selectedTransferDate
        ? moment(selectedTransferDate).format("YYYY-MM-DD")
        : "",
      externalAppUpdate: isFisNoVisible ? (fisNo === 'Y' ? 'N' : 'Y') : '',
      paymentMode: null,
      payorAccountId: null,
      // ...(isFisNoVisible  && {externalAppUpdate: fisNo === 'Y' ? 'N' : 'Y'})
    };
    if (
      rbac.rbacDetails.paymentApproveRemarkMandate ==
      "Y" &&
      (!rejectionMsg ||
        rejectionMsg.trim()?.length <= 0)
    ) {
      toast.error(
        "User remarks mandatory for approval"
      );
      return;
    }
    if (showBeneficiary && !selectedBeneficiary) {
      toast.dark(
        t("resource_message:beneficiaryBankMandatory")
      );
      return;
    }
    if (pymtConf.showTransferDate === 'M' && showTransferDate && !selectedTransferDate) {
      toast.dark(
        t("resource_message:paymentTransferDateMandatory")
      );
      return;
    }
    if (adminRefNumber && !bankRefNoLiner) {
      toast.dark(
        t("resource_message:bankRefMandatory")
      );
      return;
    }
    if (bankRefNoLiner?.length == 0) {
      toast.dark(
        t("resource_message:bankRefMandatory")
      );
    }
    else {
      if (isPaidFromSAP) {
        dispatch(approveSAPPaymentManualyByLiner({ ...payload })).unwrap()
          .then((response: any) => {
            if (response.success == 'false') {
              toast.error(response.message);
            } else {
              toast.success(response.message);
            }
            setTimeout(() => {
              dispatch(updateDashbaordRefresh(true));
            }, 3000);
            onBack();
          });
      } else {
        dispatch( approvePaymentManualyByLiner({...payload,paymentRef:pymtNo})).unwrap()
          .then(() => {
            setTimeout(() => {
              dispatch(updateDashbaordRefresh(true));
            }, 3000);
            onBack();
          });
      }
    }
  }

  const multiCurrencyAllow = useSelector(
    (state: RootState) => state.blPayment.multiCurrencyAllow
  );
  // const platAmt = (0.0523 * parseFloat(paymentAmount)).toString();
  /*  useEffect(() => {
    if (
      paymentAmount &&
      profileDetails.partnerCountry !== '' &&
      pymtCurr !== '' &&
      pymtMode !== ''
    )
      try {
        axiosInstance
          .get(
            `/api/payment-gateway-v2/v2/platform/charges?pmtAmount=${paymentAmount}&countryCode=US&currency=${selectedCcy}&linerId=1&pmtMode=7`
          )
          .then((response) => {
            setPlatformfee(+response.data.totalPlatformCharge);
            setPlatformChargeConfigId(
              `${response.data?.platformChargeConfigId ?? ''}`
            );
            setTotamt(platformfee ? initAmt + platformfee : initAmt);
          });
      } catch (error) {
        console.error('Error:', error);
      }
  }, [paymentAmount, platformfee]); */

  useEffect(() => {
    if (paymentMode == PaymentMode.QRCode && (!mandatePmtId || !blNumDecrypted)) {
      dispatch(resetFileName());
      setPaymentProofMultiFiles([]);
    }
  }, [paymentMode, mandatePmtId, blNumDecrypted]);

  useEffect(() => {
   // console.log("check", pymtConf, paymentMode, disableFields)

    if (
      pymtConf.iHaveMyReferenceDefault == "Y" &&
      pymtConf.iHaveMyReference != "N" &&
      (paymentMode == PaymentMode.BankTransfer || paymentMode == VAN_PAYMENT_MODE_ID) &&
      !disableFields
    ) {

      setRadioValue("generate");
      setInputValueTemp("inputValue");
      setInputValue("");
    } else if (
      pymtConf.odexReferenceDefault == "Y" &&
      (paymentMode == PaymentMode.BankTransfer || paymentMode == VAN_PAYMENT_MODE_ID) &&
      !disableFields
    ) {
      console.log("Setting auto");
      setRadioValue("auto");
      setInputValueTemp(pymtRefNo);

    } else if (
      pymtConf.iHaveMyReferenceDefault == "N" &&
      pymtConf.odexReferenceDefault == "N" &&
      (paymentMode == PaymentMode.BankTransfer || paymentMode == VAN_PAYMENT_MODE_ID) &&
      !disableFields
    ) {

      setRadioValue("");
      setInputValue("");
    }
  }, [pymtConf, paymentMode, disableFields, location.pathname, paymentAmount, localAmount]);

  useEffect(() => {
    if (
      paymentMode == PaymentMode.CashDeposit &&
      String(paymentCountry).toUpperCase() === "AE" &&
      radioValue === "generate"
    ) {
      setRadioValue("auto");
      setInputValue("");
    }
  }, [paymentMode, paymentCountry, radioValue]);

  const isAccountMandatory = pymtConf?.accountDetails == "M";
  /*   const showPlatformFee = pymtConf?.platformFee == "Y"; */

  const activePaymentProofFiles = paymentProofMultiFiles?.filter((f) => f.active == "1") ?? [];
  const isPaymentProofMandatory = showPaymentProofMultiAttachment ? pymtConf?.paymentProofMultiAttachment == 'M' : pymtConf?.paymentProofAttachment == 'M';
  const isPaymentProofInvalid = activePaymentProofFiles.length == 0 || activePaymentProofFiles.some((f) => (f.loading ?? 0) != 0 && (f.loading ?? 0) != 100) || !activePaymentProofFiles.every((f) => isPaymentProofReady(f));
  const isSubmitDisabledByPaymentProof = pymtConf && radioValue === "generate" && isPaymentProofMandatory && isPaymentProofInvalid;
  const isSubmitDisabledByAmountPaid =
    isAmountPaidRequired && !amountPaidType;

  const hideExchangeCashBankDetails =
    paymentMode == PaymentMode.CashDeposit && String(paymentCountry).toUpperCase() === "AE";

  const isApproveDisabledByPartialPop =
    showAmountPaidCheckbox &&
    (amountPaidType ?? "") == "PARTIAL" &&
    !allowPartialPopApproval;

  const isCustomerBeneficiaryDetailsMissing =
    isCustomerBeneficiaryAccountEditEnabled &&
    (!selectedBeneficiary ||
      (Number(paymentMode) === PaymentMode.BankTransfer &&
        (!selected || !bnkName.trim() || !acName.trim())));
  const isSubmitDisabled = paymentMode == PaymentMode.MtnMobileMoney ? false : (
		(inputValue?.length < pymtConf?.minLength || inputValue?.length > pymtConf?.maxLength) ||
		(!radioValue && pymtConf && pymtConf.odexReferenceDefault == "N" && pymtConf.iHaveMyReferenceDefault == "N") ||
		 isSubmitDisabledByPaymentProof ||
		  isSubmitDisabledByAmountPaid ||
		   isCustomerBeneficiaryDetailsMissing ||
		  (!hideExchangeCashBankDetails && paymentMode != VAN_PAYMENT_MODE_ID && pymtConf && pymtConf?.personEmaiID == 'M' && (financePersonEmail?.length == 0 || !!financePersonEmailError)) ||
		  (!isCustomerBeneficiaryAccountEditEnabled && !hideExchangeCashBankDetails && pymtConf && pymtConf?.accountDetails == 'M' && (!acName || acName?.trim?.().length === 0))
		  );

  // const showQRCode = paymentMode == PaymentMode.QRCode && radioValue === "auto" && (mandatePmtId || pymtRefNo || blNumDecrypted) && !editPayment;

    const showQRCode = paymentMode == PaymentMode.QRCode && radioValue === "auto" && (mandatePmtId || pymtRefNo || blNumDecrypted) && !editPayment && profileDetails.partnerType === "customer" && paymentDetails?.pmtStatus != "Paid";

  const showVanPaymentMode = useMemo(
    () => new URLSearchParams(location.search).get("vanPay") === "1",
    [location.search]
  );

  const pymtModeOptionsForSelect = useMemo(() => {
    if (showVanPaymentMode) {
      return [{ value: VAN_PAYMENT_MODE_ID, text: "VAN Payment" }];
    }
    return pymtModeOptions.filter(
      (item: any) =>
        item.value !== PaymentMode.Excluded ||
        cdnCountry == paymentCountry ||
        pmtStatus
    );
  }, [
    pymtModeOptions,
    showVanPaymentMode,
    cdnCountry,
    paymentCountry,
    pmtStatus,
  ]);

  const selectedPymtModeLabel =
    pymtModeOptionsForSelect.find(
      (item: any) => String(item.value) === String(paymentMode)
    )?.text ?? "";
  const isWalletPaymentMode =
    paymentMode == PaymentMode.Wallet ||
    String(selectedPymtModeLabel).toLowerCase().includes("wallet");
  const hideWalletInvoiceDetails =
    isWalletPaymentMode && String(paymentCountry).toUpperCase() === "AE";

  const isFisNoVisible =
    profileDetails.partnerType === "liner" &&
    pmtStatus?.toUpperCase() !== "PAID" &&
    pmtStatus?.toUpperCase() !== "AUTO_APPROVED" &&
    pmtStatus?.toUpperCase() !== "CANCELLED" &&
    pmtStatus?.toUpperCase() !== "REJECTED" &&
    pmtStatus !== "1" &&
    pymtConf?.isFisNoVisible === "Y" &&
    // (paymentCountry === 'US' || paymentCountry === 'CA') &&
    rbac.rbacDetails.paymentApproveReject === "Y" &&
    !editPayment


  //console.log("maxLength",pymtConf?.maxLength);
  useEffect(() => {
    if (paymentMode == VAN_PAYMENT_MODE_ID) {
      setFinancePersonEmailError("");
      return;
    }
    if (!financePersonEmail) {
      setFinancePersonEmailError(pymtConf?.personEmaiID === 'M' ? "Finance person email is required" : "");
    } else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(financePersonEmail)) {
      setFinancePersonEmailError("Invalid email address");
    } else {
      setFinancePersonEmailError("");
    }
  }, [financePersonEmail, pymtConf?.personEmaiID, paymentMode]);

  return (
    <div className=" h-100">
      <div className="border card" style={{ minHeight: "100%" }}>
        <Card.Header
          className="d-flex align-items-center border-bottom sticky-top bg-white"
          style={{ zIndex: 2 }}
        >
          <FontAwesomeIcon
            style={{ position: "relative", left: "0" }}
            icon={faArrowAltCircleLeft}
            className="cursor-pointer fa-lg "
            onClick={handleBack}
          />
          {window.location.pathname === `${APP_PATH_PREFIX}/payment/new` && (
            <h2 className="fs-0 text-primary ms-2 p-0 m-0">
              {selecteData?.length > 0 || location.pathname == `${APP_PATH_PREFIX}/payment/new`
                ? t("resource_2:paymentDetails")
                : t("resource_2:addFund")}
            </h2>
          )}
          {window.location.pathname !== `${APP_PATH_PREFIX}/payment/new` && (
            <h2 className="fs-0 text-primary ms-2">
              {t("resource_2:paymentDetails")}
            </h2>
          )}
          {lastEndpoint == "instructionpayment" && (
            <h2 className="fs-0 text-primary ms-2">
              {t("resource_2:paymentDetails")}
            </h2>
          )}
          {usdPayableAmount && zarPayableAmount ? (
            <h5 className="fs-0">Payable &nbsp;&nbsp;&nbsp;&nbsp;</h5>
          ) : (
            ""
          )}
          {usdPayableAmount ? (
            <h5 className="fs-0">USD {usdPayableAmount}</h5>
          ) : (
            ""
          )}{" "}
          &nbsp;&nbsp;&nbsp;&nbsp;
          {zarPayableAmount ? (
            <h5 className="fs-0">ZAR {zarPayableAmount}</h5>
          ) : (
            ""
          )}
         
        </Card.Header>
        <div className="card-body" style={{ zIndex: showMainLayout ? 1 : 2 }}>
              <div className='col-lg-12 mb-1'>
                  {paymentMode == 11 &&
                    String(paymentCountry || dataCountry || "")
                      .trim()
                      .toUpperCase() === "CI" &&
                    t('resource_message:paymentNote') != '' &&
                    t('resource_message:paymentNote') !=
                      'resource_message:paymentNote' && (
                    <div className='col-lg-12 mb-1'>
                      <Form.Label style={{ color: '#f5822a' }}>
                        <ul style={{ paddingLeft: '15px', marginBottom: 0 }}>
                          {t('resource_message:paymentNote')
                            .split('\n')
                            .map((v: any, i: number) => (
                              <li key={i}>{v}</li>
                            ))}
                        </ul>
                      </Form.Label>
                    </div>
                  )}
                </div>
          {disableFields ? (
            <>
             
              {
                /*  rbac.rbacDetails.showPlatformFees == 'Y'  */[
                  7, 8, 10,
                ].includes(+paymentMode)/*  && showPlatformFee */ && (
                  <>
                    <Form.Label column lg={3} className="fs--1 opacity-75 my-0">
                      Invoice Amount
                    </Form.Label>
                    <Form.Label className={`fs--1 opacity-75 my-0 mx-1`}>
                      <span
                        className="mx-2 my-0"
                        style={{ paddingLeft: "90px" }}
                      >
                        {window.location.pathname.includes("blsliderpayment")
                          ? `${selectedCcy} ${totalInvAmt}`
                          : `${selectedCcy} ${totalInvAmt}`}
                      </span>
                    </Form.Label>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "18px",
                      }}
                    >
                      <Form.Label
                        column
                        lg={3}
                        className="fs--1 opacity-75 my-0"
                      >
                        Platform Fees
                      </Form.Label>
                      <Form.Label className="fs--1 opacity-75 my-0 mx-1">
                        <span
                          className="mx-2 my-0"
                          style={{ paddingLeft: "90px" }}
                        >
                          {window.location.pathname.includes("blsliderpayment")
                            ? `${selectedCcy} ${formatNumber(platformfee)}`
                            : `${selectedCcy} ${formatNumber(platformfee)}`}
                          <a
                            href={`${process.env.REACT_APP_CLIENT_APP_HOST}/api/edo-rest-v1/v1/payment/getInvoicePdf/${pymtId}`}
                            target="_blank"
                            style={{ marginLeft: "0.7rem", fontSize: "12px" }}
                          >
                            Invoice
                          </a>
                        </span>
                      </Form.Label>
                    </div>
                  </>
                )
              }
              <Form.Group as={Row} controlId="payableAmount.input">
                <Form.Label column lg={5} className="fs--1">
                  {t("resource_2:payableAmount")}
                </Form.Label>

                {multiCurrencyAllow &&
                  localAmount &&
                  localAmount != "" &&
                  localccy &&
                  localccy != "" ? (
                  <Col lg={6}>
                    <div className="d-flex py-1 ">
                      <div className="pe-5">
                        <p className="text-600 fs--1 fw-medium mb-0">
                          {selectedCcy}
                        </p>{" "}
                        <h4 className="text-800 mb-0">{paymentAmount} </h4>
                      </div>
                      <div className="pe-5">
                        <p className="text-600 fs--1 fw-medium mb-0">
                          {localccy}
                        </p>{" "}
                        <h4 className="text-800 mb-0">{localAmount} </h4>
                      </div>
                    </div>
                  </Col>
                ) : (
                  <Col lg={6}>
                    <InputGroup>
                      <Col lg={5}>
                        <Form.Control
                          value={selectedCcy}
                          disabled={true}
                        ></Form.Control>
                      </Col>
                      <Col lg={7}>
                        <Form.Control
                          aria-label={t("resource_2:payableAmount")}
                          aria-describedby="payable-amount"
                          value={formatNumber(paymentAmount)}
                          disabled={disableFields}
                        />
                      </Col>
                    </InputGroup>
                  </Col>
                )}
              </Form.Group>
            </>
          ) : (
            <>
              <PayableAmount dataCountry={paymentCountry} pymtConf={pymtConf} showFinalCurrency={showFinalCurrency} />
            </>
          )}
          <hr />

          <div>
            {pmtId != 0 &&
              invoiceDetails?.data !== undefined &&
              invoiceDetails?.data.length >= 0 && (
                <h6>
                   {t("resource_2:payableInvoice")} {" "}
                  <span className="badge badge-soft-primary rounded-pill ms-2 mt-2">
                    {pmtNumberdataCount.length}
                  </span>
                </h6>
              )}
            {pmtId != 0 && (
              pymtConf?.showOrHidePayableInvoice === "Y" ? (

                <ToggleDiv
                  className='col-lg-12 mb-2'
                  style={{ zIndex: 1 }}
                  showText={'Click here to view Payable Invoice'}
                  hideText={'Click here to hide Payable Invoice'}
                  initial={false}
                >

                  <PaymentInvoiceList
                    paymentCountry={paymentCountry}
                    selectedCcy={selectedCcy}
                    pmtID={pymtId}
                    inputValue={inputValue}
                  />
                </ToggleDiv>

              ) : (
                <PaymentInvoiceList
                  paymentCountry={paymentCountry}
                  selectedCcy={selectedCcy}
                  pmtID={pymtId}
                  inputValue={inputValue}
                />

              )



            )}
          </div>

          <Form.Group className="pb-1 pe-1 ps-3" controlId="blPayment.pmtId">
            <Form.Control type="hidden" className="fs--1" value={pmtId} />
          </Form.Group>
          <Form.Group className="pb-3 pe-0 ps-0" controlId="blPayment.input1">
            <Form.Label className="fs--1">
              {t("resource_2:paymentMode")}
            </Form.Label>
            {/* <a
              href="#!"
              // onClick={(e) => {
              //   e.preventDefault();
              // }}
								onClick={async () => {
								  await openDocumentInNewTab({
								    url: '/api/edo-rest-v2/v2/common/openDocument',
								    params: {
								      id: encryptAndEncode(pymtId),
								      moduleTp: 'PAYMENT_PROOF',
								      linerId: encryptAndEncode(
								        profileDetails.partnerType === 'liner'
								          ? profileDetails?.partnerId
								          : selectedLinerId
								      ),
								    },
								  });
								}}
              className="fs--2 fw-bold"
              style={{ whiteSpace: 'nowrap' }}
            >
              Payment Guide
            </a> */}
            {(paymentMode == PaymentMode.QRCode && pymtConf?.showPaymentGuide) &&
              <a href={`${pymtConf?.showPaymentGuide ?? ''}`} target="_blank" className="center fs--2 fw-bold mx-2"><FontAwesomeIcon icon={faDownload} className="fs--2 mx-1" style={{ color: '#f5822a' }}></FontAwesomeIcon>Payment Guide</a>}

            <Form.Select
              aria-label="Payment Mode"
              className={`${classNames({ "text-400": !paymentMode })} fs--1`}
              onChange={onChangePaymentMode}
              value={paymentMode}
              disabled={
                showVanPaymentMode ||
                isLiner ||
                (isCustomer
                  ? Boolean(pmtId)
                  : disableFields)
              }
            >
              {/*  {pymtModeOptions.filter((item: any) => item.value != PaymentMode.Excluded || (cdnCountry == paymentCountry) || pmtStatus) */}
              {pymtModeOptionsForSelect.map((option: any) =>
                  option.value == PaymentMode.Wallet &&
                    selecteData?.length == 0 &&
                    window.location.pathname === `${APP_PATH_PREFIX}/payment/new` ? (
                    <></>
                  ) : option.value == PaymentMode.Wallet && rbac.rbacDetails.useCredit != "Y" ? (
                    <></>
                  ) : (
                    <option
                      className="text-dark"
                      key={option.value}
                      value={option.value}
                    >
                      {option.text}
                      {option.value == 2 && totalCreditAmount
                        ? " -- USD " +
                        formatNumber(totalCreditAmount) +
                        "(" +
                        creditBalanceList.length +
                        ")"
                        : ""}
                    </option>
                  )
                )}
              {/*  <option className='text-dark' value='1'>
                Bank Transfer
              </option>
              <option className='text-dark' value='2'>
                Credit Balance
              </option>
              <option className='text-dark' value='3'>
                PayCargo
              </option> */}
            </Form.Select>
          </Form.Group>

          {paymentMode && showBeneficiaryAccount && (
            <Form.Group
              className="pb-3 pe-0 ps-0"
              controlId="blPayment.beneficiaryAccount"
            >
              <Form.Label className="fs--1">Beneficiary Account</Form.Label>
              <Form.Select
                aria-label="Beneficiary Account"
                className="fs--1"
                disabled={
                  isPaidPayment ||
                  (isLiner
                    ? !canEditLinerBeneficiary
                    : !canEditCustomerBeneficiary)
                }
                value={selectedBeneficiary}
                onChange={handleBeneficiaryChange}
                required
              >
                <option value="">Select Beneficiary Account</option>
                {beneficiaryAccountOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          )}
          {paymentMode == PaymentMode.PayCargo && profileDetails.partnerType === "customer" ? (
            <div
              className="co-lg-12"
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                color: "#f5822a",
              }}
            >
              {" "}
              There can be additional charges applicable by Paycargo as a part
              of their platform utilization fee{" "}
            </div>
          ) : (
            ""
          )}

          {paymentMode ? (
            <>
              {paymentMode == PaymentMode.BankTransfer ||
              paymentMode == PaymentMode.CashDeposit ||
              paymentMode == VAN_PAYMENT_MODE_ID ||
              paymentMode == PaymentMode.BankTransferAlt ||
              paymentMode == PaymentMode.Cheque ||
              paymentMode == PaymentMode.QRCode ? (
                <>
                  <Form className="p-0">
                    {paymentMode == PaymentMode.BankTransfer ||
                    paymentMode == PaymentMode.CashDeposit ||
                    paymentMode == VAN_PAYMENT_MODE_ID ? (
                      <>
                        <Row className="mb-3">
                          {!hideExchangeCashBankDetails && (
                          <>
                          <div className="pb-0 pe-3 ps-3 mt-3">
                            {bankData.length == 0 ? (
                              <span>
                                <p
                                  style={{
                                    fontSize: "12px",
                                    marginBottom: "0px",
                                  }}
                                >
                                  {t("resource_12:addBankAccountMessage")}
                                  <Link to={`${APP_PATH_PREFIX}/user/profile`}>
                                    {" "}{t("resource_2:clickHere")}
                                  </Link>
                                </p>
                              </span>
                            ) : (
                              <></>
                            )}
                              <Form.Group controlId="blPayment.input2">
                                <Form.Label className="fs--1">
                                  {t("resource_2:bankName")}
                                </Form.Label>
                                <Form.Select
                                  aria-label="Bank Name"
                                  className="fs--1"
                                  disabled={disableFields}
                                  value={selected}
                                  onChange={handleChange}
                                  required
                                >
                                  <option value="">Select Bank</option>
                                  {
                                    bankData.map((option: any) => (
                                      <option
                                        key={option.value}
                                        value={option.value}
                                      >
                                        {option.text}
                                      </option>
                                    ))
                                  }
                                </Form.Select>
                              </Form.Group>
                          </div>
                          <>
                          <Col lg={3}>
                            <Form.Group controlId="blPayment.input2">
                              <Form.Label className="fs--1">
                                {t("resource_2:bankName")}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                className="fs--1"
                                value={bnkName}
                                disabled
                                onChange={(e) => {
                                  setBnkName(e.target.value);
                                  dispatch(setDirty());
                                }}
                                required={isCustomerBeneficiaryAccountEditEnabled}
                              />
                            </Form.Group>
                          </Col>

                          <Col lg={4}>
                            <Form.Group controlId="blPayment.input3">
                              <Form.Label
                                className="fs--1"
                                disabled={disableFields}
                              >
                                {t("resource_2:A/CNo")}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                className={`fs--1 ${!isCustomerBeneficiaryAccountEditEnabled && isAccountMandatory && !acName && !disableFields ? "is-invalid" : ""}`}
                                disabled
                                value={acName}
                                onChange={(e) => {
                                  setAcName(e.target.value);
                                  dispatch(setDirty())
                                }}
                                required={isCustomerBeneficiaryAccountEditEnabled || isAccountMandatory}
                              />
                              {!isCustomerBeneficiaryAccountEditEnabled && isAccountMandatory && !acName && !disableFields && <div className="invalid-feedback">{t("resource_message:accountNumberIsRequired")}</div>}
                            </Form.Group>
                          </Col>
                          </>

                          {/* Finance person email ID field — hidden for VAN Payment */}
                          {paymentMode != VAN_PAYMENT_MODE_ID && (
                          <Col lg={4}>
                            <Form.Group controlId="blPayment.financePersonEmailId">
                              <Form.Label className="fs--1" style={{ whiteSpace: 'nowrap' }}>
                                {t("resource_4:financePersonEmailID")}
                              </Form.Label>
                              <Form.Control
                                type="email"
                                className={`fs--1 ${financePersonEmailError ? "is-invalid" : ""}`}
                                disabled={disableFields}
                                value={financePersonEmail}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                  setFinancePersonEmail(e.target.value);
                                  dispatch(setDirty());
                                }
                                }
                                required={pymtConf?.personEmaiID === 'M'}
                                placeholder={t("resource_4:financePersonEmailID")}
                                style={{ width: '100%', minWidth: '200px', whiteSpace: 'nowrap' }}
                              />
                              {financePersonEmailError && (
                                <div className="invalid-feedback">
                                  {financePersonEmailError}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                          )}
                          </>
                          )}

                          {/* Beneficiary Bank field */}
                          {!!(beneficiaryAccountList?.length>0 && ( showBeneficiary || paymentDetails?.beneficiaryAccount )) &&
                            <Col lg={8}>
                              <Form.Group controlId="blPayment.financePersonEmailId">
                                <Form.Label className="fs--1" style={{ whiteSpace: 'nowrap' }}>
                                  Beneficiary Bank
                                </Form.Label>
                                <Form.Select disabled={!!paymentDetails?.beneficiaryAccount} size="sm" onChange={(e) => setSelectedBeneficiary(e?.target?.value)} value={parseInt(selectedBeneficiary)??''}>
                                  <option key={0} value='' hidden={true}>Select Beneficiary Account</option>
                                  {
                                    beneficiaryAccountList?.map(({label,value}:{label:string,value:string})=>(
                                      <option key={value} value={value}>{label}</option>
                                    ))
                                  }
                                </Form.Select>
                              </Form.Group>
                            </Col>
                          }

                          {/* Payment Transfer Date field */}
                          {!!(showTransferDate || paymentDetails?.transactionDate) &&
                            <Col lg={8}>
                              <Form.Group controlId="blPayment.paymentTransferDate">
                                <Form.Label className="fs--1" style={{ whiteSpace: 'nowrap' }}>
                                  Payment Transfer Date
                                </Form.Label>
                                <DatePicker
                                  portalId="root-portal"
                                  className="fs--1 form-control"
                                  selected={selectedTransferDate}
                                  onChange={(date: any) => setSelectedTransferDate(date)}
                                  onKeyDown={(e) => e.preventDefault()}
                                  dateFormat={getDateFormat()}
                                  maxDate={new Date()}
                                  isClearable={!paymentDetails?.transactionDate}
                                  disabled={!!paymentDetails?.transactionDate}
                                  popperProps={{ strategy: 'fixed' }}
                                />
                              </Form.Group>
                            </Col>
                          }
                        </Row>
                      </>
                    ) : (
                      <>
                        {(paymentMode != PaymentMode.Cheque && paymentMode != PaymentMode.QRCode) ? (
                          <div style={{ fontWeight: "bold" }}>
                            <p
                              style={{ fontSize: "12px", marginBottom: "6px" }}
                            >
                              Please use the ODeX Ref Number while transacting
                              on PayCargo. You can visit PayCargo here{" "}
                              <a
                                href="https://paycargo.com "
                                target="_blank"
                                style={{ fontWeight: "bold" }}
                              >
                                https://paycargo.com{""}
                              </a>
                            </p>
                            <p
                              style={{ fontSize: "12px", marginBottom: "16px" }}
                            >
                              Alternatively you can also enter the PayCargo
                              Payment Ref ID for the set of invoice/s for which
                              you have initiated a payment on PayCargo.
                            </p>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    )}
                    <fieldset>
                      {(paymentMode == PaymentMode.BankTransfer ||
                        paymentMode == PaymentMode.CashDeposit ||
                        paymentMode == VAN_PAYMENT_MODE_ID ||
                        (paymentMode == PaymentMode.QRCode && !showQRCode)) &&
                      paymentCountry != "PK" ? (
                        <div className="mb-2" style={{ fontWeight: "bold" }}>
                          <p style={{ fontSize: "12px", marginBottom: "0px" }}>
                            {paymentMode == PaymentMode.CashDeposit ? t(
                              "resource_message:paymentModeMesForCashDeposit"
                            ) :
                              t(
                                "resource_message:paymentModeMesForBankTransfer"
                              )
                            }
                          </p>
                        </div>
                      ) : (
                        ""
                      )}
                      <legend> {t("resource_3:yourReferenceNo")}</legend>
                      <hr />
                      {(isCustomerChequeReference ||
                        (isLinerChequeReference && chequeOdexReference)) && (
                        <Form.Group
                          className="mb-2"
                          controlId="blPayment.odexGeneratedChequeReference"
                        >
                          <Form.Label className="fs--1">
                            ODeX Generated Number
                          </Form.Label>
                          <Form.Control
                            className="fs--1"
                            type="text"
                            value={chequeOdexReference}
                            disabled
                          />
                        </Form.Group>
                      )}
                      <Form.Group className="mb-2" controlId="blPayment.input4">
                        {paymentCountry === "PK" ? (
                          ""
                        ) : (
                          <>
                            <Form.Label
                              className={paymentMode == PaymentMode.Cheque ? "d-none" : "fs--1 "}
                              htmlFor="auto"
                            >
                              <input
                                type="radio"
                                id="auto"
                                value="auto"
                                name="refNo"
                                onChange={() => {
                                  setInputValue("");
                                  setRadioValue("auto");
                                  // props.refInput.disabled = 'true';
                                }}
                                checked={radioValue === "auto" ? true : false}
                                disabled={
                                  paymentMode == PaymentMode.Cheque ? true : disableFields
                                }
                              />{" "}
                              {t("resource_2:oDeXGenerate")}
                            </Form.Label>
                          </>
                        )}
                        {!hideExchangeCashBankDetails &&
                          (paymentMode == PaymentMode.Cheque ||
                            pymtConf?.iHaveMyReference != "N") && (
                        <Form.Label className="fs--1" htmlFor="generate">
                          <input
                            type="radio"
                            id="generate"
                            value="generate"
                            name="refNo"
                            onChange={(e) => {
                              setInputValueTemp(inputValue);
                              setInputValue("");
                              setRadioValue("generate");
                            }}
                            style={
                              paymentMode == PaymentMode.Cheque || paymentCountry === "PK"
                                ? { marginLeft: "0px" }
                                : { marginLeft: "20px" }
                            }
                            checked={radioValue === "generate" ? true : false}
                            disabled={!editPayment ? disableFields : false}
                          />{" "}
                          {paymentMode == PaymentMode.Cheque
                            ? "Cheque No."
                            : paymentCountry === ""
                              ? t("resource_2:slipNumber")
                              : t("resource_5:iHaveMyRefNo")}
                        </Form.Label>
                        )}
                        {pymtConf.bankUserManual==='Y'/*  paymentCountry === 'SG' || paymentCountry == 'ZA' || paymentCountry === 'MY' || paymentCountry === 'JO' || paymentCountry === 'UG'  */ ? <span className="f--1" onClick={() => { setPaymentRefInfo(true) }}>{radioValue === 'generate' && (paymentMode == PaymentMode.BankTransfer || paymentMode == VAN_PAYMENT_MODE_ID) ? <FontAwesomeIcon icon={faInfoCircle} className="ps-2 pe-2" style={{ cursor: 'pointer' }} ></FontAwesomeIcon> : ""}</span> : ""}
                        {pymtConf.bankUserManual==='Y'/* paymentCountry === 'SG' || paymentCountry == 'ZA' || paymentCountry === 'MY' || paymentCountry === 'JO' || paymentCountry === 'UG' */ ?
                          <>
                            {radioValue === 'generate' &&
                            (paymentMode == PaymentMode.BankTransfer || paymentMode == VAN_PAYMENT_MODE_ID) ? (
                              <div style={{ marginBottom: '12px' }}>
                                <a
                                  href="#"
                                  style={{ fontSize: '12px', textDecoration: 'underline', color: '#007bff', cursor: 'pointer', display: 'inline-block', marginTop: '4px' }}
                                  onClick={e => { e.preventDefault(); setPaymentRefInfo(true); }}
                                >
                                  Click here to download the payment manual as per your respective bank
                                </a>
                              </div>
                            ) : ""}
                          </>
                          : ""}

                        <Form.Control
                          className="fs--1"
                          disabled={
                            (editPayment === true && radioValue === "auto") ||
                              !editPayment
                              ? disableFields ||
                              (radioValue === "auto" ? true : false)
                              : false
                          }
                          type="text"
                          // name='refInput'
                          ref={modalCloseFocus}
                          value={inputValue}
                          // onChange={(e) =>
                          //   setInputValue(
                          //     e.target.value /* .replace(/ /g, '') */
                          //   )
                          // }
                          onChange={handleInputChange}
                          onBlur={handleInputBlur}
                          maxLength={pymtConf?.maxLength}
                          minLength={pymtConf?.minLength}
                          placeholder={
                            pymtConf?.minLength <= 1
                              ? `Up to ${pymtConf?.maxLength} characters`
                              : `Between ${pymtConf?.minLength} to ${pymtConf?.maxLength} characters`
                          }
                        />


                        {/* {inputError && <div className="text-danger">{inputError}</div>} */}
                      </Form.Group>
                      {profileDetails.partnerType === "liner" &&
                        pmtStatus?.toUpperCase() !== "PAID" &&
                        pmtStatus !== "1" &&
                        pmtStatus?.toUpperCase() !== "REJECTED" &&
                        pmtStatus?.toUpperCase() !== "AUTO_APPROVED" &&
                        rbac.rbacDetails.paymentApproveReject === "Y" && (
                          <Form.Group controlId="blPayment.input2">
                            <Form.Label className="fs--1">
                              {t("resource_2:bankRefNo")}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              className="fs--1"
                              // disabled={disableFields}
                              value={bankRefNoLiner}
                              onChange={(e) =>
                                setBankRefNoLiner(e.target.value)
                                // handleBankRefBlur(e.target.value)}
                              }
                              onBlur={handleBankRefBlur}
                            />
                          </Form.Group>
                        )}
                      {profileDetails.partnerType === "liner" &&
                        pmtStatus.toUpperCase() !== "PAID" &&
                        pmtStatus?.toUpperCase() != "AUTO_APPROVED" &&
                        pmtStatus !== "1" &&
                        pmtStatus?.toUpperCase() != "REJECTED" &&
                        rbac.rbacDetails.showAdminRefNo === "Y"
                        && false && (
                          <Form.Group controlId="blPayment.input4">
                            <Form.Label className="fs--1">
                              {t("resource_2:adminRefNo")}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              className="fs--1"
                              // disabled={disableFields}
                              value={adminRefNumber}
                              onChange={(e) => {
                                setAdminRefNumber(e.target.value);
                                dispatch(setDirty());
                              }
                              }
                            />
                          </Form.Group>
                        )}
                        {((
                            pmtStatus?.toUpperCase() !== "PAID" &&
                            pmtStatus?.toUpperCase() !== "AUTO_APPROVED" &&
                            pmtStatus !== "1" &&
                            (
                             (
                                pymtConf.showLinerRemarks === "Y" &&
                                profileDetails.partnerType === "liner" &&
                                rbac.rbacDetails.paymentApproveReject === "Y"
                             ) ||
                              pymtConf.showLinerRemarksToAll === "Y"
                             ))|| !!rejectionMsg)
                        && (
                          <>
                          <legend>{t("resource_2:liner_remarks")}</legend>
                         <Form.Group
                            className="mb-2 mt-2"
                            controlId="blPayment.input4"
                          >
                            <Form.Control
                              className="fs--1"
                              type="text"
                              onChange={e => {
                                setrejectionMsg(e.target.value)
                                dispatch(updatePymtData({ ...paymentDetails, linerRemarks: e.target.value }));
                              }
                              }
                              disabled={profileDetails.partnerType !== "liner" || pmtStatus=="Paid" || pmtStatus=="Auto_Approved" || pmtStatus == "1"}
                              value={rejectionMsg}
                              maxLength={150}
                              minLength={10}
                              placeholder="Enter Remark"
                            />
                          </Form.Group>
                          </>
                        )}
                      {/*   {radioValue === 'generate' && !inputValue && (
                        <h6 className='text-warning m-0 fs--1'>
                          Please enter your Ref No &nbsp;&nbsp;
                        </h6>
                      )} */}

                      {radioValue === "generate" &&
                        !(!editPayment ? disableFields : false) &&
                        inputValue?.length < pymtConf?.minLength &&
                        (paymentMode == PaymentMode.BankTransfer ||
                          paymentMode == PaymentMode.CashDeposit ||
                          paymentMode == VAN_PAYMENT_MODE_ID) && (
                          <h6 className="text-warning m-0 fs--1">
                            Please enter your Ref No Between{" "}
                            {pymtConf?.minLength} to {pymtConf?.maxLength}{" "}
                            characters &nbsp;&nbsp;
                          </h6>
                        )}
                      {!(!editPayment ? disableFields : false) &&
                        inputValue?.length < pymtConf?.minLength &&
                        paymentMode == PaymentMode.Cheque && (
                          <h6 className="text-warning m-0 fs--1">
                            Please enter Cheque No Between {pymtConf?.minLength}{" "}
                            to {pymtConf?.maxLength} characters &nbsp;&nbsp;
                          </h6>
                        )}
                      {/*     {radioValue === "generate" && inputValue.length < 6 && paymentMode == PaymentMode.Cheque && (
                        <h6 className="text-warning m-0 fs--1">
                          Please enter your Cheque no should be in 6 characters
                          &nbsp;&nbsp;
                        </h6>
                      )} */}

                      {profileDetails.partnerType === "liner" &&
                        pmtStatus.toUpperCase() !== "PAID" &&
                        pmtStatus?.toUpperCase() != "AUTO_APPROVED" &&
                        pmtStatus !== "1" &&
                        pmtStatus?.toUpperCase() != "REJECTED" &&
                        paymentTransactionDetails?.length > 0 &&
                        rbac?.rbacDetails?.showPaymentTransaction == "Y" && (
                          <ToggleDiv
                            className="col-lg-12 mb-2 demmurageTable"
                            style={{ zIndex: 1 }}
                            showText={"Click here to view transaction details"}
                            hideText={"Click here to hide transaction details"}
                            initial={false}
                          >
                            <DataTable
                              data={paymentTransactionDetails ?? []}
                              gridName="pmt_transaction_details"
                              columns={transactionDetailsCols}
                              sortable={false}
                              searchable={false}
                              showColumnFilter={false}
                              selection={false}
                              perPage={10}
                              pagination={false}
                              showExport={false}
                              uniqueFilterKey="pmt_transaction_details"
                              autoHeight={true}
                              maxHeight="7rem"
                              staticHiddenCols={[]}
                            />
                          </ToggleDiv>
                        )}
                    </fieldset>
                    {!(paymentMode == PaymentMode.QRCode && radioValue === "auto") && (isAttachmentMandate ||
                      (disableFields == false &&
                        ((showPaymentProofMultiAttachment || showPaymentProofAttachment) ||
                          /*     selectedFileServerPath[1] != "" || */
                          paymentMode == PaymentMode.Cheque))) ? (
                      <Form.Group controlId="blPayment.input5">
                        {showAmountPaidCheckbox && (
                          <div className="mb-2">
                            <Form.Label className="fs--1 mb-1 d-block">
                              Amount Paid
                              {isAmountPaidRequired && (
                                <span className="text-danger ms-1">*</span>
                              )}
                            </Form.Label>
                            <div className="d-flex flex-wrap gap-3 align-items-center">
                              <Form.Check
                                type="checkbox"
                                id="amount-paid-partial"
                                label="Partial Paid"
                                checked={amountPaidType == "PARTIAL"}
                                disabled={
                                  (disableFields && !isAttachmentMandate) ||
                                  isAmountPaidCheckboxDisabledByProof
                                }
                                onChange={() => {
                                  const next =
                                    amountPaidType == "PARTIAL" ? null : "PARTIAL";
                                  setAmountPaidType(next);
                                  if (next) setAmountPaidError(false);
                                  dispatch(setDirty());
                                }}
                              />
                              <Form.Check
                                type="checkbox"
                                id="amount-paid-full"
                                label="Full Paid"
                                checked={amountPaidType == "FULL"}
                                disabled={
                                  (disableFields && !isAttachmentMandate) ||
                                  isAmountPaidCheckboxDisabledByProof
                                }
                                onChange={() => {
                                  const next =
                                    amountPaidType == "FULL" ? null : "FULL";
                                  setAmountPaidType(next);
                                  if (next) setAmountPaidError(false);
                                  dispatch(setDirty());
                                }}
                              />
                            </div>
                            {profileDetails.partnerType != "liner" && (
                              <div className="fs--1 mt-1">
                                Select "Partial Paid" only if you have paid a partial amount. Select "Full Paid" only if you have paid the complete invoice amount. Please ensure the selected option matches the attached Proof of Payment (POP).
                              </div>
                            )}
                            {amountPaidError && (
                              <div className="text-danger fs--1 mt-1">
                                Please select/ update the Amount Paid checkbox
                              </div>
                            )}
                          </div>
                        )}
                        <div className="mt-3 mb-2">

                          <Form.Label className="fs--1 d-flex flex-row mb-0">
                            { } {t("resource_2:bankProof")}
                            {!!paymentProofMultiFiles?.[0]?.loading &&
                              !showPaymentProofMultiAttachment && (
                              <td>
                                <UploadIndicator
                                  style={{ marginLeft: "20px" }}
                                  progress={paymentProofMultiFiles?.[0]?.loading ?? 0}
                                  fail={paymentProofMultiFiles?.[0]?.loading == -1}
                                />
                              </td>
                            )}
                          </Form.Label>

                          {(isAttachmentMandate || radioValue === "generate" || paymentMode == PaymentMode.Cheque) &&
                            pymtConf?.paymentProofMessage == "Y" &&
                            <span style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "12px" }} >
                              The amount of payment proof must match with the total amount of selected invoices or else payment cannot be clearly timely.
                            </span>
                          }
                        </div>
                        {!(paymentMode == PaymentMode.QRCode && radioValue === "auto") &&
                          (showPaymentProofMultiAttachment ? (
                            <DropzoneThingNew
                              files={paymentProofMultiFiles?.filter((f) => f.active == "1") ?? []}
                              selected={handlePaymentProofMultiSelected}
                              pending={handlePaymentProofMultiPending}
                              fulfilled={handlePaymentProofMultiFulfilled}
                              failed={handlePaymentProofMultiFailed}
                              clear={handlePaymentProofMultiClear}
                              uploadEndpoint="/api/edo-rest-v1/v1/view/file"
                              acceptedTypes={{
                                "application/pdf": [".pdf"],
                                "image/png": [".png"],
                                "image/jpeg": [".jpg", ".jpeg"],
                              }}
                              maxFiles={paymentProofMaxFiles}
                              maxFileSize={5}
                              maxFileNameLength={60}
                              allowMultiple={paymentProofMaxFiles > 1}
                              disabled={disableFields && !isAttachmentMandate}
                              getDocumentLink={getPaymentProofDocumentLink}
                              openDocument={openPaymentProofDocument}
                              className="mb-2"
                            />
                          ) : (
                            <Form.Control
                              type="file"
                              disabled={disableFields && !isAttachmentMandate}
                              onChange={handleFileChange}
                              style={{ marginBottom: "10px" }}
                              required={pymtConf?.paymentProofAttachment == "M"}
                            />
                          ))}
                        <>
                          {(isAttachmentMandate ||
                            (radioValue === "generate" &&
                              inputValue !== "" &&
                              (showPaymentProofMultiAttachment
                                ? pymtConf?.paymentProofMultiAttachment == "M"
                                : pymtConf?.paymentProofAttachment == "M") &&
                              paymentMode != PaymentMode.Cheque) ||
                            (inputValue !== "" &&
                              (showPaymentProofMultiAttachment
                                ? pymtConf?.paymentProofMultiAttachment == "M"
                                : pymtConf?.paymentProofAttachment == "M") &&
                              paymentMode == PaymentMode.Cheque)) &&
                            !paymentProofMultiFiles?.some((f) =>
                              isPaymentProofReady(f)
                            ) ? (
                            <h6 className="text-warning m-0 fs--1">
                              Please attach Payment Proof &nbsp;&nbsp;
                            </h6>
                          ) : (
                            ""
                          )}
                        </>
                        {/*    {showPaymentProofAttachment && !paymentProofFileName && <div className="invalid-feedback">Payment proof is required</div>} */}
                      </Form.Group>
                    ) : (
                      <>
                            {!editPayment &&
                              showAmountPaidCheckbox &&
                              (
                                <div className="mb-2">
                                  <Form.Label className="fs--1 mb-1 d-block">
                                    Amount Paid
                                  </Form.Label>
                                  <div className="d-flex flex-wrap gap-3 align-items-center">
                                    <Form.Check
                                      type="checkbox"
                                      id="amount-paid-partial-view"
                                      label="Partial Paid"
                                      checked={amountPaidType == "PARTIAL"}
                                      disabled
                                    />
                                    <Form.Check
                                      type="checkbox"
                                      id="amount-paid-full-view"
                                      label="Full Paid"
                                      checked={amountPaidType == "FULL"}
                                      disabled
                                    />
                                  </div>
                                </div>
                              )}
                        {(!showPaymentProofMultiAttachment || !editPayment) && (
                        <div>
                          <Form.Label className="fs--1">
                            {(showPaymentProofMultiAttachment || showPaymentProofAttachment) ? (
                              <>
                                {(paymentProofMultiFiles?.filter((f) => f.active == "1") ?? []).length > 0
                                  ? `${t("resource_2:bankProof")} `
                                  : ""}
                              </>
                            ) : (
                              ""
                            )}
                          </Form.Label>
                          {["M", "O"].includes(
                            showPaymentProofMultiAttachment
                              ? pymtConf?.paymentProofMultiAttachment
                              : pymtConf?.paymentProofAttachment
                          ) &&
                            paymentProofMultiFiles
                              ?.filter(
                                (f) =>
                                  f.active == "1" &&
                                  !f.tempFileName &&
                                  f.fileName != null &&
                                  f.fileName != "" &&
                                  f.fileName != "undefined"
                              )
                              ?.map((f) => (
                                <span
                                  key={f.rowNumber ?? f.popAttId ?? f.fileName}
                                  className="d-block mb-2"
                                >
                                  <span
                                    className="text-primary cursor-pointer fs--1 text-decoration-underline d-inline"
                                    onClick={() =>
                                      openDocumentInNewTab({
                                        url: '/api/edo-rest-v2/v2/common/openDocument',
                                        params: {
                                          id: encryptAndEncode(f?.popAttId),
                                          moduleTp: 'PAYMENT_PROOF_NEW',
                                          linerId: encryptAndEncode(
                                            profileDetails.partnerType === 'liner'
                                              ? profileDetails?.partnerId
                                              : selectedLinerId
                                          ),
                                        },
                                      })
                                    }
                                  >
                                    {f.fileName}
                                  </span>
                                </span>
                              ))}
                          {["M", "O"].includes(
                            showPaymentProofMultiAttachment
                              ? pymtConf?.paymentProofMultiAttachment
                              : pymtConf?.paymentProofAttachment
                          ) &&
                            paymentProofMultiFiles
                              ?.filter(
                                (f) =>
                                  f.active == "1" &&
                                  f.tempFileName &&
                                  f.fileName != null &&
                                  f.fileName !== "" &&
                                  f.fileName !== "undefined"
                              )
                              ?.map((f) => (
                                <span
                                  key={f.rowNumber ?? f.popAttId ?? f.fileName}
                                  className="d-block mb-2 fs--1 text-muted"
                                >
                                  {/* {f.tempFileName} */}
                                  {f.fileName}
                                </span>
                              ))}
                        </div>
                        )}
                        {
                          /* disableFieldsForNotSubmitted == true &&
                          showPaymentProofAttachment || paymentMode == PaymentMode.Cheque  */ !(paymentMode == PaymentMode.QRCode && radioValue === "auto") && editPayment && (
                            <div>
                              <Form.Group controlId="blPayment.input5">
                                {showAmountPaidCheckbox && (
                                  <div className="mb-2 mt-2">
                                    <Form.Label className="fs--1 mb-1 d-block">
                                      Amount Paid
                                      {isAmountPaidRequired && (
                                        <span className="text-danger ms-1">*</span>
                                      )}
                                    </Form.Label>
                                    <div className="d-flex flex-wrap gap-3 align-items-center">
                                      <Form.Check
                                        type="checkbox"
                                        id="amount-paid-partial-edit"
                                        label="Partial Paid"
                                        checked={amountPaidType == "PARTIAL"}
                                        disabled={
                                          !editPayment ||
                                          isAmountPaidCheckboxDisabledByProof
                                        }
                                        onChange={() => {
                                          const next =
                                            amountPaidType == "PARTIAL"
                                              ? null
                                              : "PARTIAL";
                                          setAmountPaidType(next);
                                          if (next) setAmountPaidError(false);
                                          dispatch(setDirty());
                                        }}
                                      />
                                      <Form.Check
                                        type="checkbox"
                                        id="amount-paid-full-edit"
                                        label="Full Paid"
                                        checked={amountPaidType == "FULL"}
                                        disabled={
                                          !editPayment ||
                                          isAmountPaidCheckboxDisabledByProof
                                        }
                                        onChange={() => {
                                          const next =
                                            amountPaidType == "FULL" ? null : "FULL";
                                          setAmountPaidType(next);
                                          if (next) setAmountPaidError(false);
                                          dispatch(setDirty());
                                        }}
                                      />
                                    </div>
                                    {profileDetails.partnerType != "liner" && (
                                      <div className="fs--1 mt-1">
                                        Select "Partial Paid" only if you have paid a partial amount. Select "Full Paid" only if you have paid the complete invoice amount. Please ensure the selected option matches the attached Proof of Payment (POP).
                                      </div>
                                    )}
                                    {amountPaidError && (
                                      <div className="text-danger fs--1 mt-1">
                                        Please select/ update the Amount Paid checkbox
                                      </div>
                                    )}
                                  </div>
                                )}
                                <div className="mt-3 mb-2">
                                  <Form.Label className="fs--1 d-flex flex-row mt-3 mb-0">
                                    { } {t("resource_2:bankProof")}
                                    {!!paymentProofMultiFiles?.[0]?.loading &&
                                      !showPaymentProofMultiAttachment && (
                                      <td>
                                        <UploadIndicator
                                          style={{ marginLeft: "20px" }}
                                          progress={paymentProofMultiFiles?.[0]?.loading ?? 0}
                                          fail={paymentProofMultiFiles?.[0]?.loading == -1}
                                        />
                                      </td>
                                    )}
                                  </Form.Label>
                                  {(isAttachmentMandate || radioValue === "generate" || paymentMode == PaymentMode.Cheque ) &&
                                    pymtConf?.paymentProofMessage == "Y" &&
                                    <span style={{ fontSize: "12px", fontWeight: "bold", marginBottom: "12px" }} >
                                      The amount of payment proof must match with the total amount of selected invoices or else payment cannot be clearly timely.
                                    </span>
                                  }
                                </div>
                                {!(paymentMode == PaymentMode.QRCode && radioValue === "auto") &&
                                  (showPaymentProofMultiAttachment ? (
                                    <DropzoneThingNew
                                      files={paymentProofMultiFiles?.filter((f) => f.active == "1") ?? []}
                                      selected={handlePaymentProofMultiSelected}
                                      pending={handlePaymentProofMultiPending}
                                      fulfilled={handlePaymentProofMultiFulfilled}
                                      failed={handlePaymentProofMultiFailed}
                                      clear={handlePaymentProofMultiClear}
                                      uploadEndpoint="/api/edo-rest-v1/v1/view/file"
                                      acceptedTypes={{
                                        "application/pdf": [".pdf"],
                                        "image/png": [".png"],
                                        "image/jpeg": [".jpg", ".jpeg"],
                                      }}
                                      maxFiles={paymentProofMaxFiles}
                                      maxFileSize={5}
                                      maxFileNameLength={60}
                                      allowMultiple={paymentProofMaxFiles > 1}
                                      // disabled={disableFields && !isAttachmentMandate}
                                      disabled={editPayment ? false : true}
                                      getDocumentLink={getPaymentProofDocumentLink}
                                      className="mb-2"
                                    />
                                  ) : (
                                    <Form.Control
                                      type="file"
                                      /*    disabled={
                                    disableFields  && !isAttachmentMandate
                                  } */
                                  disabled={editPayment ? false : true}
                                      onChange={handleFileChange}
                                      style={{ marginBottom: "10px" }}
                                      required={showPaymentProofAttachment}
                                    />
                                  ))}
                                <>
                                  {((isAttachmentMandate &&
                                    (paymentProofMultiFiles?.filter((f) => f.active == "1") ?? [])
                                      .length == 0) ||
                                    (radioValue === "generate" &&
                                      inputValue !== "" &&
                                      (showPaymentProofMultiAttachment
                                        ? pymtConf?.paymentProofMultiAttachment ==
                                          "M"
                                        : pymtConf?.paymentProofAttachment ==
                                          "M") &&
                                      paymentMode != PaymentMode.Cheque &&
                                      (paymentProofMultiFiles?.filter((f) => f.active == "1") ?? [])
                                        .length == 0) ||
                                    (inputValue !== "" &&
                                      (showPaymentProofMultiAttachment
                                        ? pymtConf?.paymentProofMultiAttachment ==
                                          "M"
                                        : pymtConf?.paymentProofAttachment ==
                                          "M") &&
                                      paymentMode == PaymentMode.Cheque &&
                                      (paymentProofMultiFiles?.filter((f) => f.active == "1") ?? [])
                                        .length == 0)) &&
                                    !paymentProofMultiFiles?.some((f) =>
                                      isPaymentProofReady(f)
                                    ) ? (
                                    <h6 className="text-warning m-0 fs--1">
                                      Please attach Payment Proof &nbsp;&nbsp;
                                    </h6>
                                  ) : (
                                    ""
                                  )}
                                </>
                                {(showPaymentProofMultiAttachment ||
                                  showPaymentProofAttachment) &&
                                  !paymentProofMultiFiles?.some((f) =>
                                    isPaymentProofReady(f)
                                  ) && (
                                  <div className="invalid-feedback">
                                    Payment proof is required
                                  </div>
                                )}
                              </Form.Group>
                            </div>
                          )
                        }
                      </>
                    )}
                  </Form>
                </>
              ) : paymentMode == PaymentMode.Wallet && !hideWalletInvoiceDetails ? (
                <div>
                  <Form.Group
                    as={Row}
                    className="ml-3 mb-2"
                    controlId="payableAmount.input3"
                  >
                    <Col lg={4}>
                      <Form.Label className="fs--1">
                        {t("resource_2:selectedAmount")}
                      </Form.Label>
                    </Col>
                    <Col>
                      <Form.Label className="fs--1">
                        {formatNumber(selectedCreditAmount)}
                      </Form.Label>
                    </Col>
                  </Form.Group>
                  <CreditBalance />
                </div>
              ) : (
                ""
              )}
              {(isFisNoVisible
              ) && (
                  <div className='col-lg-12' style={{ zIndex: 1 }}>
                    <Form.Check
                      type="checkbox"
                      id="fis-no-checkbox"
                      label="FIS No"
                      checked={fisNo === 'Y'}
                      onChange={e => {
                        setFisNo(prev => (prev === 'Y' ? 'N' : 'Y'));
                      }}
                      disabled={
                        profileDetails.partnerType === "customer" ||
                        rbac.rbacDetails.paymentApproveReject !== "Y" ||
                        pymtConf?.isFisNoVisible !== "Y"
                        // (paymentCountry !== 'US' && paymentCountry !== 'CA')
                      }
                    />
                  </div>
                )
              }

              {showQRCode && (
                <>

                  <div className="row">
                    <div className="col-lg-5 mb-1 text-center">
                      <span className="fs--1 fw-bold">QR Payment</span>
                    </div>
                    {/* <div className="col-lg-2 mb-1 text-center p-0">
                      <span className="fs--1 fw-bold">OR</span>
                    </div> */}

                    <div className="col-lg-5 mb-1 text-center p-0">
                      <a
                      href={pymtConf?.paymentLink ? pymtConf?.paymentLink : ""}
                      onClick={e => {
                        if (!pymtConf?.paymentLink) e.preventDefault();
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="fs--1 fw-bold text-primary"
                      style={{ textDecoration: "underline", cursor: "pointer"}}
                    >
                      Click here to Pay
                    </a>
                    </div>

                  </div>
                  {/* <div className="d-flex align-items-center mb-2">
                    <span className="fs--1 fw-bold me-3">QR Payment</span>

                    <span className="fs--1 fw-bold me-3" style={{ marginLeft: "20px" }}>OR</span>

                    <a
                      href="https://pay.maviance.com/drawer/962936017"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="fs--1 fw-bold text-primary"
                      style={{ textDecoration: "underline", cursor: "pointer", marginLeft: "40px" }}
                    >
                      Click here to Pay
                    </a>
                  </div> */}

                  <div className="row">
                    <div className="col-lg-12 mb-1">
                      <div className="row align-items-center">
                        <div className="col-lg-5 col-md-4 col-sm-12 text-center mb-2">

                          {/* <div className="mb-2 fs--1 fw-bold" style={{ textDecoration: "underline" }}>
                    SCAN ME
                  </div> */}
                          <img
                            src={accessBankQrCode}
                            alt="Preview QR Code"
                            style={{
                              width: "100%",
                              maxWidth: "150px",
                              // borderRadius: "6px",
                              // maxHeight: "80px",
                              objectFit: "contain"
                            }}
                          />
                          {/* <div className="mt-2 fs--1 fw-bold">OR</div>
                        <a
                          href="https://pay.maviance.com/drawer/962936017"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="fs--1 fw-bold text-primary"
                          style={{ textDecoration: "underline", cursor: "pointer" }}
                        >
                          Click here to Pay
                        </a> */}
                        </div>

                        <div className="col-lg-7 col-md-8 col-sm-12">
                          <>
                            <div className="mb-3 fs--1">
                              <h6 className="mb-2 fs--1">
                                Kindly follow below steps to make payments using QR code.
                              </h6>
                              {/* <div className="mb-1 fs--1">1. Scan the QR code.</div>
                      <div className="mb-1 fs--1">2. Use ODeX Reference Number and Amount as provided above.</div>
                      <div className="mb-1 fs--1">3. Complete payment.</div> */}

                              <ol className="mb-0 mt-1">
                                <li className="m-0 fs--1">Scan the QR code.</li>
                                <li className="m-0 fs--1">Use ODeX Reference Number and Amount as provided above.</li>
                                <li className="m-0 fs--1">Complete payment.</li>
                              </ol>
                            </div>
                          </>

                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="d-flex justify-content-center align-items-center">
                {(paymentLoaderCheck || enkapPollingActive) ? (
                  <div className="text-center">
                    <Lottie
                      animationData={infiniteLoop}
                      loop={true}
                      style={{ height: "80px", width: "80px" }}
                    />
                    {enkapPollingActive && (
                      <div className="mt-2 fw-bold" style={{ color: "#2c7be5" }}>
                        Verifying Payment...
                      </div>
                    )}
                  </div>
                ) : paymentMode == PaymentMode.PayCargo &&
                  pmtStatus !== "1" &&
                  pmtStatus !== "Paid" ? (
                  <>
                    <div style={{ zIndex: 500 }}>
                      <p />
                      <PaycargoCheckout
                        ref={paycargoRef}
                        options={options}
                        pcTransactions={selectedTransactions}
                      />
                    </div>
                  </>
                ) : (paymentMode == PaymentMode.OnlineGateway || paymentMode == PaymentMode.Excluded) &&
                  pmtStatus?.toUpperCase?.() !== "1" &&
                  pmtStatus?.toUpperCase?.() !== "PAID" &&
                  pmtStatus?.toUpperCase?.() !== "SUBMITTED" &&
                  platformChargeConfigId != "" ? (
                  <>
                    {selectedAmount.length <= 0 ? (
                      "No invoices Selected"
                    ) : (
                      <div style={{ zIndex: 500 }}>
                        <p />
                        <App
                          payload={{
                            invoiceIds: selectedAmount.map((i: any) => i.invID),
                            email: profileDetails.email,
                            linerId: selectedLinerId,
                            pymtMode: paymentMode,
                            countryCode: paymentCountry,
                            platformChargeConfigId: platformChargeConfigId,
                            userName: profileDetails?.username ?? "",
                            customerCompanyName: profileDetails?.name ?? "",
                            contactNumber: profileDetails?.phnNo ?? "",
                          }}
                          quickPay={false}
                        />
                      </div>
                    )}
                  </>
                ) : paymentMode == PaymentMode.PaypalCard &&
                  pmtStatus?.toUpperCase?.() !== "1" &&
                  pmtStatus?.toUpperCase?.() !== "PAID" &&
                  pmtStatus?.toUpperCase?.() !== "SUBMITTED" &&
                  platformChargeConfigId != "" ? (
                  <>
                    {selectedAmount.length <= 0 ? (
                      "No invoices Selected"
                    ) : (
                      <div style={{ zIndex: 500 }} className="w-100">
                        <p />
                        <PayPalCard
                          payload={{
                            invoiceIds: selectedAmount.map((i: any) => i.invID),
                            email: profileDetails.email,
                            linerId: selectedLinerId,
                            countryCode: paymentCountry,
                            pymtMode: paymentMode,
                            platformChargeConfigId: platformChargeConfigId,
                            userName: profileDetails?.username ?? "",
                            customerCompanyName: profileDetails?.name ?? "",
                            contactNumber: profileDetails?.phnNo ?? "",
                          }}
                          quickPay={false}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  paymentMode != PaymentMode.OnlineGateway &&
                  paymentMode != PaymentMode.PaypalCard &&
                  paymentMode != PaymentMode.Excluded && (
                    <div className="d-flex flex-column align-items-center gap-2">
                      {paymentMode == PaymentMode.MtnMobileMoney && (
                        <h6 className="text-warning m-0 fs--1 text-center">
                          <FontAwesomeIcon icon={faExclamationCircle} className="me-1" />
                          {t("resource_1:enkapCheckoutNote")}
                        </h6>
                      )}
                      {depositSlipPaymentId && !editPayment ? (
                        renderDepositSlipButton(depositSlipPaymentId)
                      ) : (
                        <Button
                          variant="falcon-primary"
                          size="sm"
                          className="me-2"
                          hidden={disableFields}
                          onClick={handleSubmit}
                          type="submit"
                          disabled={isSubmitDisabled || (paymentMode == PaymentMode.MtnMobileMoney && paymentLoaderCheck)}
                        >
                          <FontAwesomeIcon icon={faSave} className="me-2" />
                          {paymentMode == PaymentMode.MtnMobileMoney ? t("resource_1:paymentCheckOut") : t("resource_1:submit")}
                        </Button>
                      )}
                    </div>
                  )
                )}
                <Button
                  className="me-2 d-none"
                  variant="falcon-danger"
                  size="sm"
                  hidden={disableFields}
                >
                  <FontAwesomeIcon icon={faRedo} className="me-2" />
                  {t("resource_1:reset")}
                </Button>
              </div>
              {showCustomerPaymentActions ? (
                <div className="d-flex justify-content-center align-items-center">
                  {cancelPaymentLoader ? (
                    <Lottie
                      animationData={infiniteLoop}
                      loop={true}
                      style={{ height: "80px", width: "80px" }}
                    />
                  ) : (
                    <>
                      <Button
                        variant="falcon-primary"
                        size="sm"
                        className="me-2"
                        hidden={editPayment}
                        disabled={
                          pmtStatus == "1" || pmtStatus == "Paid" ? true : false
                        }
                        onClick={() => {
                          toast.info(
                            <>
                              Please ensure the <b>Reference No.</b> is entered accurately and review the amount as incorrect details may lead to payment mismatches in the system.
                            </>,
                            {
                              theme: "dark",
                              autoClose: 5000,
                            }
                          );

                          dispatch(setEditPayment(true));
                          setLoading(false);
                        }}
                      >
                        <FontAwesomeIcon icon={faEdit} className="me-2" />
                        {t("resource_1:edit")}
                      </Button>
                      <Button
                        variant="falcon-danger"
                        size="sm"
                        className="me-2"
                        hidden={editPayment}
                        onClick={() => setPaymentCancel(true)}
                      >
                        <FontAwesomeIcon icon={faCancel} className="me-2" />
                        {t("resource_2:cancelpayment")}
                      </Button>
                      {canDownloadEximDepositSlip &&
                        renderDepositSlipButton(Number(pmtId), "me-2")}
                    </>
                  )}
                </div>
              ) : (
                <></>
              )}

              {canDownloadEximDepositSlip &&
                !editPayment &&
                !showCustomerPaymentActions &&
                !showLinerApprovalActions && (
                <div className="d-flex justify-content-center align-items-center mt-4">
                  {renderDepositSlipButton(Number(pmtId))}
                </div>
              )}
              {showLinerApprovalActions && (
                  <div className="d-flex justify-content-center align-items-center mt-4">
                    {acceptPaymentLoader || rejectPaymentLoader ? (
                      <Lottie
                        animationData={infiniteLoop}
                        loop={true}
                        style={{ height: "80px", width: "80px" }}
                      />
                    ) : (
                      <>
                        {canDownloadEximDepositSlip &&
                          renderDepositSlipButton(Number(pmtId), "me-3")}
                        <Button
                          variant="success"
                          className="me-3 approve"
                          size="sm"
                          hidden={editPayment}
                          disabled={isApproveDisabledByPartialPop}
                          onClick={handleApprovePayment}
                        >
                          <FontAwesomeIcon
                            icon={faCheck}
                            className="me-2 approve"
                          />
                          {t("resource_1:approve")}
                        </Button>
                        <Button
                          variant="danger reject"
                          size="sm"
                          className="me-3"
                          hidden={editPayment}
                          onClick={() => {
                            if (pymtConf.showLinerRemarks === "Y" && rejectionMsg.length == 0) {
                              toast.dark(
                                t("resource_message:remarksMandatory")
                              );
                            } else {
                              dispatch(
                                rejectPayment({
                                  pmtId: pymtId,
                                  // blId: selectedBlId,
                                  currency: pymtCurr,
                                  paymentSubmittedByEmail:paymentDetails?.userEmailId,
                                  rejectionMsg: rejectionMsg,
                                  paymentRef:pymtNo,
                                  country: paymentCountry
                                })
                              )
                                .unwrap()
                                .then(() => {
                                  setTimeout(() => {
                                    if (
                                      window.location.pathname.includes(
                                        "blsliderpayment"
                                      )
                                    ) {
                                      dispatch(updateDashbaordRefresh(true));
                                      // navigate(`${APP_PATH_PREFIX}/payment`);
                                      onBack();
                                    } else {
                                      navigate(`${APP_PATH_PREFIX}/home`);
                                    }
                                  }, 3000);
                                });
                            }
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faTimes}
                            className="me-2 reject"
                          />
                          {t("resource_1:reject")}
                        </Button>

                        {rbac.rbacDetails.revisitPayment == "Y" && (
                          <Button
                            variant="falcon-primary"
                            size="sm"
                            hidden={editPayment}
                            onClick={() => {
                              if (!rejectionMsg ||
                                rejectionMsg.trim()?.length <= 0) {
                                toast.error("Remarks are mandatory.");
                                return;
                              }
                              dispatch(revisitPayment({ pymtId, linerRemarks: !linerRemarks ? rejectionMsg : linerRemarks }))
                                .unwrap()
                                .then((response: any) => {
                                  if (response.status == "success") {
                                    toast.success(response.message);
                                  } else {
                                    toast.error(
                                      response.message ??
                                      "Something went wrong, please try again later!"
                                    );
                                  }
                                });
                              onBack();
                              setTimeout(() => {
                                dispatch(updateDashbaordRefresh(true));
                              }, 2000);
                            }}
                          >
                            <FontAwesomeIcon
                              style={{ color: "#f5822a" }}
                              icon={faClock}
                              className="me-2 reject"
                            />
                            Revisit
                          </Button>
                        )}

                        {rbac.rbacDetails.sendPaymentToLiner == "Y" &&
                          pymtConf.sendToLiner == "Y" && (
                            <Button
                              variant="falcon-primary"
                              size="sm"
                              className="mx-3"
                              onClick={() => {
                                setShowRevisitModal(true);
                              }}
                            >
                              <FontAwesomeIcon
                                style={{ color: "#f5822a" }}
                                icon={faPaperPlane}
                                className="me-2 reject"
                              />
                              Send To Liner
                            </Button>
                          )}
                      </>
                    )}
                  </div>
                )}
              {editPayment && pmtId ? (
                loading ? (
                  <div
                    style={{
                      display: "flex",
                      alignContent: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Lottie
                      animationData={infiniteLoop}
                      loop={true}
                      style={{
                        height: "40px",
                        width: "40px",
                        alignSelf: "center",
                      }}
                    />
                  </div>
                ) : (
                  <div className="d-flex justify-content-center align-items-center">
                    <Button
                      variant="falcon-primary"
                      size="sm"
                      className="me-2"
                      hidden={!editPayment}
                      type="submit"
                      onClick={() => {
                        setLoading(true);
                        if (multiplePmtRef) {
                          setShowPaymentConfirm(true);
                          setNewPaymentRef(false);
                        } else {
                          checkValidationAndUpdate();
                          // setShowPaymentConfirm(true);
                          // setNewPaymentRef(false);
                        }
                      }}
                      disabled={

                        ((isAttachmentMandate &&
                          activePaymentProofFiles.length === 0 &&
                          !(paymentMode == PaymentMode.QRCode && radioValue === "auto")) ||
                          (radioValue === "generate" &&
                            inputValue !== "" &&
                            isPaymentProofMandatory &&
                            paymentMode != PaymentMode.Cheque &&
                            activePaymentProofFiles.length == 0) ||
                          (inputValue !== "" &&
                            isPaymentProofMandatory &&
                            paymentMode == PaymentMode.Cheque &&
                            activePaymentProofFiles.length == 0) ||
                          (isPaymentProofMandatory && isPaymentProofInvalid))
                          ? true
                          : loading
                              ? true
                              : inputValue?.length >= pymtConf?.minLength
                                ? false
                                : paymentMode != PaymentMode.Cheque || inputValue?.length == 0
                      }
                    >
                      <FontAwesomeIcon icon={faSave} className="me-2" />
                      {t("resource_1:submit")}
                    </Button>
                    <Button
                      className="me-2"
                      variant="falcon-danger"
                      size="sm"
                      hidden={!editPayment}
                      onClick={() =>
                      // _onCloseForm
                      {
                        setRadioValue(radioVal);
                        dispatch(setEditPayment(false));
                        dispatch(updatePymtData(paymentDetails));
                        const popAttachments = paymentDetails?.popAttachments;
                        setPaymentProofMultiFiles(
                          (Array.isArray(popAttachments)
                            ? popAttachments
                            : []
                          ).map((att: any) => ({
                            rowNumber: crypto.randomUUID(),
                            popAttId: att?.popAttId ?? undefined,
                            docId: att?.docId ?? paymentProofDocId,
                            fileName: att?.fileName ?? "",
                            filePath: att?.filePath ?? "",
                            tempFilePath: "",
                            tempFileName: "",
                            loading: 100,
                            active: att?.active ?? "1",
                          }))
                        );
                        setInputValue(
                          isSplitChequeReference
                            ? paymentDetails?.bankRefNo ?? ""
                            : paymentDetails.odexRefNo != ""
                              ? paymentDetails.odexRefNo
                              : paymentDetails.bankRefNo
                        );
                        const clearedPaidStatus = paymentDetails?.amountPaidStatus;
                        setAmountPaidType(
                          clearedPaidStatus == "PARTIAL" || clearedPaidStatus == "FULL"
                            ? clearedPaidStatus
                            : null
                        );
                        setAmountPaidError(false);
                        if (initialInvoiceDetailsPmtId) {
                          if (initialInvoiceDetailsPmtId?.data.length > 0)
                            dispatch(
                              selectedPmtNumber(
                                initialInvoiceDetailsPmtId?.data
                              )
                            );
                        }
                      }
                      }
                    >
                      {/*  <FontAwesomeIcon icon={faCancel} className='me-2' /> */}
                      <FontAwesomeIcon icon={faEraser} className="me-2" />
                      {t("resource_1:clear")}
                    </Button>
                  </div>
                )
              ) : (
                <></>
              )}
            </>
          ) : (
            ""
          )}

          {
            // Submit button for attachment mandate
            isAttachmentMandate && !(paymentMode == PaymentMode.QRCode && radioValue === "auto") && (
              <div
                style={{
                  display: "flex",
                  alignContent: "center",
                  justifyContent: "center",
                }}
              >
                <Button
                  variant="falcon-primary"
                  size="sm"
                  className="me-2"
                  disabled={(paymentProofMultiFiles?.filter((f) => f.active == "1") ?? []).length == 0}
                  onClick={() => {
                    dispatch(
                      updatePaymentAttachment({
                        pmtId: mandatePmtId,
                        popAttachments: buildPopAttachments(),
                        linerId,
                        showAmountPaidCheckbox,
                        ...getAmountPaidPayload(),
                      })
                    )
                      .unwrap()
                      .then((success) => {
                        if (success) {
                          setTimeout(() => {
                            navigate(
                              location.pathname.replace(/\/unpaid.*/, "/unpaid")
                            );
                          }, 2000);
                        }
                      });
                  }}
                >
                  <FontAwesomeIcon icon={faSave} className="me-2" />
                  {t("resource_1:submit")}
                </Button>
              </div>
            )
          }

       

        </div>
      </div>
      <Modal
        show={showPaymentConfirm}
        className="modal-dialog-centered"
        onHide={() => {
          setShowPaymentConfirm(false);
          setLoading(false);
          dispatch(resetPaymentLoaders());
        }}
      >
        <Modal.Header className="p-2 pb-1" closeButton>
          <Modal.Title className="h6">
            Confirm payment Reference Number
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            overflow: "auto",
          }}
        >
          {newPaymentRef ? (
            <>
              <span className="h6 me-2 mb-2">Payment Reference Number</span>
              <input
                type="text"
                className="fs--2 form-control"
                title="payment Ref"
                placeholder="Enter Payment Reference Number"
              />
            </>
          ) : (
            <>
              <div className="mb-2">
                <span className="h6 me-2">
                  Invoice number has different payment Ref No. Do you want to
                  proceed payment with Ref No:
                </span>
                <span className="fw-bold h6">{inputValue} ?</span>
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <Button
                  variant="falcon-primary"
                  size="sm"
                  className="me-2"
                  onClick={() => {
                    setShowPaymentConfirm(false);
                    handleUpdate();
                    setTimeout(() => {
                      dispatch(updateDashbaordRefresh(true));
                    }, 3000);
                  }}
                  disabled={inputValue?.length > 0 ? false : true}
                >
                  Yes
                </Button>
                <Button
                  className="me-2"
                  variant="falcon-danger"
                  size="sm"
                  onClick={() => {
                    setShowPaymentConfirm(false);
                    setLoading(false);
                    dispatch(resetPaymentLoaders());
                  }}
                >
                  No
                </Button>
              </div>
            </>
          )}
        </Modal.Body>
        {newPaymentRef && (
          <Modal.Footer
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div className="d-flex justify-content-center align-items-center">
              <Button
                variant="falcon-primary"
                size="sm"
                className="me-2"
                onClick={() => {
                  modalCloseFocus.current.focus();
                  setShowPaymentConfirm(false);
                }}
              >
                ok
              </Button>
            </div>
          </Modal.Footer>
        )}
      </Modal>

      <Modal
        show={showDuplicacy}
        onHide={() => {
          setshowDuplicacy(false);
          setLoading(false);
          dispatch(resetPaymentLoaders());
        }}
      >
        <Modal.Header className="p-2 pb-1" closeButton>
          <Modal.Title className="h6">
            {duplicayMsg}.Do you want to proceed with this Reference No?
          </Modal.Title>
        </Modal.Header>
        {/*       <Modal.Body
          style={{
            overflow: 'auto',
          }}
        >
         </Modal.Body> */}
        <div className="d-flex justify-content-center align-items-center p-2">
          <Button
            variant="falcon-primary"
            size="sm"
            className="me-2"
            onClick={() => {
              setshowDuplicacy(false);
              handleDuplicacy();
            }}
          // disabled={inputValue.length > 0 ? false : true}
          >
            Yes
          </Button>
          <Button
            className="me-2"
            variant="falcon-danger"
            size="sm"
            onClick={() => {
              setpaymentRefFocus(true);
              setshowDuplicacy(false);
              setLoading(false);
              dispatch(resetPaymentLoaders());
            }}
          >
            No
          </Button>
        </div>
      </Modal>

      <Modal
        show={showEditDuplicacy}
        onHide={() => {
          setShowEditDuplicacy(false);
          setLoading(false);
          dispatch(resetPaymentLoaders());
        }}
      >
        <Modal.Header className="p-2 pb-1" closeButton>
          <Modal.Title className="h6">
            {editDuplicayMsg}.
            {methodName &&
              methodName.toString().trim() !== "" &&
              " Do you want to proceed with this Reference No?"}
          </Modal.Title>
        </Modal.Header>
        {/*       <Modal.Body
          style={{
            overflow: 'auto',
          }}
        >
         </Modal.Body> */}
        {methodName && methodName.toString().trim() !== "" ? (
          <div
            style={{ marginBottom: "1rem" }}
            className="d-flex justify-content-center align-items-center"
          >
            <Button
              variant="falcon-primary"
              size="sm"
              className="me-2"
              onClick={() => {
                {
                  console.log(
                    "pymtConf?.paymentProofAttachment",
                    pymtConf?.paymentProofAttachment,
                    paymentProofMultiFiles?.[0]?.fileName,
                    paymentProofMultiFiles?.[0]?.tempFilePath
                  );
                }
                setShowEditDuplicacy(false);
                if (methodName && methodName.toString().trim() !== "") {
                  if (methodName === "handleUpdate") {
                    handleUpdate();
                  }
                }
              }}
            // disabled={inputValue.length > 0 ? false : true}
            >
              Yes
            </Button>
            <Button
              className="me-2"
              variant="falcon-danger"
              size="sm"
              onClick={() => {
                setpaymentRefFocus(true);
                setShowEditDuplicacy(false);
                setLoading(false);
                dispatch(resetPaymentLoaders());
              }}
            >
              No
            </Button>
          </div>
        ) : (
          <div
            style={{ marginBottom: "1rem" }}
            className="d-flex justify-content-center align-items-center"
          >
            <Button
              variant="falcon-primary"
              size="sm"
              className="me-2"
              onClick={() => {
                setShowEditDuplicacy(false);
                setpaymentRefFocus(true);
              }}
            // disabled={inputValue.length > 0 ? false : true}
            >
              Okay
            </Button>
          </div>
        )}
      </Modal>

      <Modal
        show={showConfirmMsg}
        onHide={() => {
          setShowConfirmMsg(false);
          dispatch(resetPaymentLoaders());
          setLoading(false);
        }}
      >
        <Modal.Header className="p-2 pb-1" closeButton>
          <Modal.Title className="h6">
            {/*  {pmtReftabledata.length == 0
              ? 'Do you want to cancel Payment'
              : pmtNumberdata.length > pmtReftabledata.length
              ? 'Do you want to remove Invoice from the Payment '
              : ''} */}
            Do you want to proceed with the payment
          </Modal.Title>
        </Modal.Header>

        <div
          style={{ marginBottom: "1rem" }}
          className="d-flex justify-content-center align-items-center"
        >
          <Button
            variant="falcon-primary"
            size="sm"
            className="me-2"
            onClick={() => {
              setShowConfirmMsg(false);
              console.log(
                "paymentProofMultiFiles[0]",
                paymentProofMultiFiles?.[0],
                pymtConf?.paymentProofAttachment,
                paymentProofMultiFiles?.[0]?.fileName
              );

              const updatePaymentRefPayload = {
                inputValue: inputValue,
                selectedCcy: pymtCurr || selectedCcy || selectedInvoiceCurrency || "USD",
                finalCurrency: showFinalCurrency ? resolvedFinalCurr : undefined,
                showFinalCurrency,
                selectedPymtId: pymtId,
                pymtAmt: paymentAmount,
                country: String(paymentCountry ?? "").trim(),
                refType: Number(
                  paymentMode == PaymentMode.Cheque ? 3 : radioValue === "auto" ? 1 : 2
                ),
                linerId: linerId,
                payorAccountId:
                  isCustomerBeneficiaryAccountEditEnabled &&
                  Number(paymentMode) === PaymentMode.BankTransfer
                    ? selected
                    : undefined,
                beneficiaryAccount:
                  isCustomerBeneficiaryAccountEditEnabled && selectedBeneficiary
                    ? Number(selectedBeneficiary)
                    : undefined,
                popAttachments: buildPopAttachments(),
                showAmountPaidCheckbox,
                ...getAmountPaidPayload(),
              };

              dispatch(updatePaymentReferenceNo(updatePaymentRefPayload))
                .unwrap()
                .then((result) => {
                  if (result?.success == "true" || result?.success === true) {
                    setTimeout(() => {
                      navigate(`${APP_PATH_PREFIX}/payment`);
                      dispatch(updateDashbaordRefresh(true));
                      dispatch(updateSelectedRowsInvoice([]));
                      dispatch(updateSelectedAmount([]));
                    }, 2000);
                  }
                })
                .catch(() => {
                  // error toast already shown in updatePaymentReferenceNo
                });
              // handleUpdate();
            }}
          // disabled={inputValue.length > 0 ? false : true}
          >
            Yes
          </Button>
          <Button
            className="me-2"
            variant="falcon-danger"
            size="sm"
            onClick={() => {
              setpaymentRefFocus(true);
              setShowConfirmMsg(false);
              setLoading(false);
              dispatch(resetPaymentLoaders());
            }}
          >
            No
          </Button>
        </div>
      </Modal>

      <Modal show={showPaymentCancel} onHide={() => setPaymentCancel(false)}>
        <Modal.Header className="p-2 pb-1" closeButton>
          <Modal.Title className="h6">
            Do you want to Cancel the Payment?
          </Modal.Title>
        </Modal.Header>

        <div className="d-flex justify-content-center align-items-center p-2">
          <Button
            variant="falcon-primary"
            size="sm"
            className="me-2"
            onClick={() => {
              setPaymentCancel(false);
              dispatch(
                cancelPayment({
                  pmtId: pymtId,
                  // blId: selectedBlId,
                  currency: pymtCurr,
                })
              )
                .unwrap()
                .then(() => {
                  if (window.location.pathname.includes("blsliderpayment")) {
                    onBack();
                    dispatch(updateSelectedRowsInvoice([]));
                    dispatch(updateSelectedAmount([]));
                    setTimeout(() => {
                      dispatch(updateDashbaordRefresh(true));
                    }, 2000);
                  } else {
                    setTimeout(() => {
                      navigate(`${APP_PATH_PREFIX}/home`);
                    }, 3000);
                  }
                });
            }}
          // disabled={inputValue.length > 0 ? false : true}
          >
            Yes
          </Button>
          <Button
            className="me-2"
            variant="falcon-danger"
            size="sm"
            onClick={() => {
              setPaymentCancel(false);
              setLoading(false);
              dispatch(resetPaymentLoaders());
            }}
          >
            No
          </Button>
        </div>
      </Modal>
      <Modal
        show={showRevisitModal}
        onHide={() => {
          setShowRevisitModal(false);
        }}
      >
        <Modal.Header className="p-2 pb-1" closeButton>
          <Modal.Title className="h6">
            Do you want to send an email for this transaction?
          </Modal.Title>
        </Modal.Header>
        <div className="d-flex justify-content-center align-items-center p-2">
          <Button
            variant="falcon-primary"
            size="sm"
            className="me-2"
            onClick={() => {
              dispatch(
                sendMailToLiner({
                  pmtId: pymtId,
                  country: paymentCountry,
                  linerId: linerId,
                  amount: paymentDetails.paymentAmount,
                  reference: paymentDetails.odexRefNo,
                  payeeEmail: paymentDetails.userEmailId,
                })
              )
                .unwrap()
                .then((response) => {
                  if (response.status == "success") {
                    toast.success(response.message);
                  } else {
                    toast.error(
                      response.message ??
                      "Something went wrong, please try again later!"
                    );
                  }
                });
              setShowRevisitModal(false);
              onBack();

              setTimeout(() => {
                dispatch(updateDashbaordRefresh(true));
              }, 2000);
            }}
          >
            Yes
          </Button>
          <Button
            className="me-2"
            variant="falcon-danger"
            size="sm"
            onClick={() => {
              setShowRevisitModal(false);
            }}
          >
            No
          </Button>
        </div>
      </Modal>

      <PaymentRefUserGuid
        showPaymentRefInfo={showPaymentRefInfo}
        setPaymentRefInfo={setPaymentRefInfo}
        selectedCurrency={paymentCurrency}
        countryCode={paymentCountry}
      />
      <UnsavedChangesModal
        show={showModal}
        onHide={handleStayOnPage}
        onConfirm={handleLeavePage}
      />
    </div>
  );
};

export default BlPayment;
